/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 * @fileoverview Загрузчик hc/funnel
	 *     Создает экземпляр API и подменяет им временную функцию,
	 *     созданную в  сниппете {@see ./snippet.js}
	 */
	
	(function(win, Api) {
	  // Находим имя временной функцию
	  var name = win['HcFunnelGlobal'] || 'hcfunnel';
	
	  // Находим временную функцию
	  var temp = win[name];
	
	  // метки времени инициализации сниппета и счётчика
	  var timings = {
	    init_time: temp && temp.t,
	    load_time: Date.now()
	  }
	
	  // ключ в глобальном контектсе для проверки загрузки фаннела
	  var funnelLoadedName = 'hc_funnel_loaded_success';
	
	
	  // проверям, что скрипт загружен только 1 раз
	  if (win[funnelLoadedName]) {
	    // скрипт загружен дважды
	    temp('event', 'frontend', 'funnel', 'alreadyloaded', timings, {}, {
	      force: true
	    });
	
	    if (module) {
	      module.exports = temp;
	    }
	    return temp;
	  }
	
	  // Оборачиваем апи функцией, закрывающей все методы, кроме PublicCommands
	  var api = __webpack_require__(2).getInterface(new Api(), Api.PublicCommands);
	
	  var urlName = win['HcFunnelGlobalUrl'] || 'hcfunnelurl';
	  if (win[urlName]) {
	    api('url', win[urlName]);
	  }
	
	  // Из временной функции вытаскиваем время создания
	  // и очередь, чтобы скормить настоящей апишке
	  if (temp) {
	    var queue = temp.q || [];
	    for (var i = 0, l = queue.length; i < l; i++) {
	      api.apply(null, queue[i]);
	    }
	  }
	
	  // Подменяем временную функцию на настоящую
	  win[name] = api;
	
	  // запомнинаем, что скрипт уже загружен
	  win[funnelLoadedName] = true;
	
	  // Подтверждаем загрузку
	  api('event', 'frontend', 'funnel', 'loaded', timings, {}, {
	    force: true
	  });
	
	  // Принудительно отправляем фаннел, в случае если код на странице поставлен,
	  // но вызова send не было длительное время
	  setTimeout(function() {
	    if (!api('wasSent')) {
	      api('send', {platform: '__init'});
	    }
	  }, 5000);
	
	  if (module) {
	    module.exports = api;
	  }
	})(window, __webpack_require__(3));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  getInterface: function(obj, commands) {
	    if (!obj.__interfase) {
	      var dict = {};
	      for (var i = 0, l = commands.length; i < l; i++) {
	        dict[commands[i]] = true;
	      }
	
	      obj.__interfase = function(method, var_args) {
	        if (method) {
	          var args = Array.prototype.slice.call(arguments, 1);
	          return obj[method].apply(obj, args);
	        }
	        throw new Error('Undefined method ' + method);
	      };
	    }
	    return obj.__interfase;
	  }
	};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * @fileoverview Funnel implementation for web sites
	 *    {@see http://wiki.ostrovok.ru/wiki/Analytics/Funnel_v2}
	 */
	
	var hash = __webpack_require__(4);
	var Transport = __webpack_require__(5);
	var debug = __webpack_require__(7);
	var events = __webpack_require__(15);
	var proxy = __webpack_require__(16);
	var cookies = __webpack_require__(8)();
	var prefixedCookies = __webpack_require__(8)('_hcfnl_');
	var ui = __webpack_require__(17);
	
	var incognito = __webpack_require__(18);
	var trackAction = __webpack_require__(23);
	var trackBlock = __webpack_require__(26);
	var trackEvent = __webpack_require__(27);
	var trackDisplays = __webpack_require__(28);
	var syncCookies = __webpack_require__(29);
	
	/**
	 * @constructor
	 */
	var Funnel = function() {
	  window.name = window.name || Math.round(Math.random() * 100000);
	  this._hash = hash.guid();
	  this._prev_hash = prefixedCookies.get('hash') || '';
	  this._transport = new Transport('/funnel_v2');
	  this._counter = 0;
	  this._id = (+new Date()).toString(36) + '-' +
	      (((1 + Math.random()) * 10000 * 0x10000) | 0).toString(36);
	  this._funnelWasSent = false;
	  this._preSendQueue = [];
	  this._lastReq = null;
	  this._data = {
	    uidCookie: 'uid',
	    funnelUidCookie: 'funnel_uid',
	    platform: undefined,
	    sitelang: undefined,
	    navlang: navigator['language'] || navigator['systemLanguage'] ||
	             navigator['browserLanguage'] || navigator['userLanguage'],
	    noFlash: navigator.plugins['Shockwave Flash'] === undefined,
	    windowName: window.name,
	    initialUrl: null,
	    has_adblk: null,
	  };
	
	  var actionListener = proxy(this.actionHandler, this);
	  events.listen(window, 'mousedown', actionListener);
	  events.listen(window, 'submit', actionListener);
	  events.listen(window, 'contextmenu', actionListener);
	  events.listen(window, 'touchstart', actionListener);
	
	  this.block = trackBlock(this);
	  this.event = trackEvent(this);
	  this.displays = trackDisplays(this);
	
	  this.setFunnelUid();
	
	  this.checkAdblock();
	
	  this._identified = false;
	  syncCookies.periodically();
	};
	
	Funnel.prototype.setFunnelUid = function() {
	  var funnelUid = prefixedCookies.get(this._data.funnelUidCookie) || hash.funnelUid(this._id);
	
	  prefixedCookies.set(this._data.funnelUidCookie, funnelUid, 86400 * 365 * 5 * 1000);
	};
	
	Funnel.prototype.checkAdblock = function() {
	  var el = document.createElement('script');
	  el.src = ['/', ("cnt.worldota.net"), ("hc/static/master"), 'ads.js?check=true'].join('/');
	  el.onload = proxy(function() {
	    this._data.has_adblk = false;
	  }, this);
	  el.onerror = proxy(function() {
	    this._data.has_adblk = true;
	  }, this);
	
	  document.head.appendChild(el);
	};
	
	Funnel.prototype.actionHandler = function() {
	  prefixedCookies.set('hash', this._hash);
	};
	
	Funnel.prototype.send = function(opt_data, opt_post_data) {
	  try {
	    this.sendInternal(opt_data, opt_post_data);
	  } catch(ex) {
	    this.event('frontend', 'funnel', 'exception', {
	      name: ex.name,
	      stack: ex.stack
	    },
	    {},
	    {
	      force: true
	    });
	  }
	
	  if (!this._identified) {
	    syncCookies.identify();
	    this._identified = true;
	  }
	};
	
	Funnel.prototype.sendInternal = function(opt_data, opt_post_data) {
	  var data = opt_data || {};
	
	  var req = {};
	
	  // change hash
	  if (this._funnelWasSent === true) {
	      this._prev_hash = this._hash;
	      this._hash = hash.guid();
	  }
	
	  // required
	  req.screen = ui.screenSize().join('x');
	  req.pixel_ratio = ui.pixelRatio();
	  req.viewport = ui.viewportSize().join('x');
	  req.pagetype = data.pagetype;
	  req.url = document.location.href;
	  req.referer = document.referrer;
	  req.js_prev_hit_id = this._prev_hash;
	  req.js_hit_id = this._hash;
	  req.platform = data.platform || this._data.platform;
	  req.instance_id = this._id;
	  req.is_incognito = incognito();
	  req.no_flash = this._data.noFlash;
	  req.has_adblk = data.has_adblk || this._data.has_adblk;
	
	  // interface
	  req.currency = data.currency || this._data.currency;
	  req.navlang = this._data.navlang;
	  req.sitelang = data.sitelang || this._data.sitelang;
	  req.window_name = this._data.windowName;
	
	  if (this._data.initialUrl) {
	    req.initial_url = this._data.initialUrl;
	  }
	
	  // if user logged in, check special cookie
	  req.is_auth = cookies.get('is_auth');
	
	  // parent window
	  try {
	    req.is_window_top = window.self !== window.top;
	  } catch (e) {
	    req.is_window_top = true;
	  }
	
	  req.domain_uid = this.domainUid();
	
	  // connection stats
	  this.addConnectionStat(req, {
	  // effective connection type determined using a combination of recently observed rtt and downlink values
	    'connection_type':     'effectiveType',
	  // effective bandwidth estimate
	    'connection_downlink': 'downlink',
	  // effective round-trip time estimate
	    'connection_rtt':      'rtt'
	  });
	
	  for (var name in data) {
	    req[name] = data[name];
	  }
	
	  req.hit_num = ++this._counter;
	
	  debug.log('[funnel] send', req);
	
	  this._lastReq = req;
	  this._transport.send(req, opt_post_data);
	
	  if (this._funnelWasSent === false) {
	    this._funnelWasSent = true;
	    this.sendPreSendQueue();
	  }
	};
	
	Funnel.prototype.addConnectionStat = function(request, fields) {
	  if (!navigator.connection) {
	    return;
	  }
	
	  for (var field in fields) {
	    if (fields.hasOwnProperty(field)) {
	      var property = fields[field];
	
	      if (navigator.connection[property]) {
	        request[field] = navigator.connection[property];
	      }
	    }
	  }
	};
	
	Funnel.prototype.wasSent = function() {
	  return this._funnelWasSent;
	};
	
	Funnel.prototype.sendPreSendQueue = function() {
	  var item;
	  while (this._preSendQueue.length) {
	    item = this._preSendQueue.shift();
	    switch (item.type) {
	      case 'action': this.action.apply(this, item.args); break;
	      case 'block': this.block(item.display_type, item.action, item.display_id, item.unit, item.data); break;
	      case 'event': this.event(item.category, item.action, item.opt_label, item.opt_data, item.opt_post_data, item.opt_options); break;
	      case 'display': this.displays(item.opt_data); break;
	    }
	  };
	  Transport.disableQueuedMode();
	};
	
	Funnel.prototype.action = function(intention, event, context) {
	  if (this._funnelWasSent) {
	    trackAction(this.domainUid(), this._hash,
	        intention, event, context, this._lastReq, this._id);
	  } else {
	    this._preSendQueue.push({
	      type: 'action',
	      args: arguments
	    });
	  }
	};
	
	Funnel.prototype.url = function(urlPrefix) {
	  Transport.setUrlPrefix(urlPrefix);
	};
	
	Funnel.prototype.hash = function(cb) {
	  if (cb) {
	    cb(this._hash);
	  }
	  return this._hash;
	};
	
	Funnel.prototype.instanceId = function() {
	  return this._id;
	};
	
	Funnel.prototype.debug = function(enable) {
	  debug.setEnabled(enable);
	};
	
	Funnel.prototype.verbose = function(enable) {
	  this._transport.setVerbose(enable);
	};
	
	Funnel.prototype.platform = function(platform) {
	  if (platform) {
	    this._data.platform = platform;
	  }
	  return this._data.platform;
	};
	
	Funnel.prototype.counter = function() {
	  return this._counter;
	};
	
	Funnel.prototype.addRelations = function(data) {
	  data.domain_uid = this.domainUid();
	  data.funnel_js_hit_id = this._hash;
	  data.funnel_hit_num = this._counter;
	  data.funnel_instance_id = this._id;
	  data.pagetype = this._lastReq && this._lastReq.pagetype;
	};
	
	Funnel.prototype.isDebug = function() {
	  return debug.isEnabled();
	};
	
	Funnel.prototype.domainUid = function() {
	  this._data.uid = this._data.uid || cookies.get(this._data.uidCookie) || null;
	
	  return this._data.uid;
	};
	
	Funnel.prototype.funnelUid = function() {
	  this._data.funnel_uid = this._data.funnel_uid || prefixedCookies.get(this._data.funnelUidCookie) || null;
	
	  return this._data.funnel_uid;
	};
	
	Funnel.prototype.decodeUid = function(uid) {
	  function pad (hex) {
	    while (hex.length < 8) {
	      hex = '0' + hex;
	    }
	
	    return hex;
	  }
	
	  var binary = atob(uid),
	      bytes  = new Uint8Array(16),
	      parts  = new Uint32Array(bytes.buffer),
	      result = '';
	
	  for (var i = 0; i < bytes.byteLength; i++) {
	    bytes[i] = binary.charCodeAt(i);
	  }
	
	  for (var i = 0; i < parts.length; i++) {
	    result += pad(parts[i].toString(16));
	  }
	
	  return result.toUpperCase();
	};
	
	Funnel.prototype.hexDomainUid = function() {
	  return this.decodeUid(this.domainUid());
	};
	
	Funnel.prototype.hexFunnelUid = function() {
	  return this.decodeUid(this.funnelUid());
	};
	
	Funnel.PublicCommands = [
	  'currency',
	  'sitelang',
	  'uid',
	  'uidCookie',
	  'initialUrl',
	];
	
	var setter = function(name) {
	  return function(value) {
	    this._data[name] = value;
	  };
	};
	
	for (var i = 0, l = Funnel.PublicCommands.length; i < l; i++) {
	  Funnel.prototype[Funnel.PublicCommands[i]] = setter(Funnel.PublicCommands[i]);
	}
	
	Funnel.PublicCommands.push('hash', 'send', 'event', 'displays', 'platform', 'action', 'url', 'debug', 'verbose', 'instanceId', 'block', 'wasSent', 'hexDomainUid', 'hexFunnelUid', 'decodeUid');
	
	module.exports = Funnel;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	    Решение взято отсюда https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
	    Прошлая реализация была завязана на Math.random(), что давало коллизии в некотрых случаях
	    так же добавлен window.performance в качестве замены new Date
	*/
	
	
	var log2 = function(n){
	    return Math.log(n) / Math.log(2);
	}
	
	var trueRandom = (function() {
	  var crypt = window.crypto || window.msCrypto;
	
	  if (crypt && crypt.getRandomValues) {
	      // if we have a crypto library, use it
	      var random = function(min, max) {
	          var rval = 0;
	          var range = max - min;
	          if (range < 2) {
	              return min;
	          }
	
	          var bits_needed = Math.ceil(log2(range));
	          if (bits_needed > 53) {
	            throw new Error("We cannot generate numbers larger than 53 bits.");
	          }
	          var bytes_needed = Math.ceil(bits_needed / 8);
	          var mask = Math.pow(2, bits_needed) - 1;
	          // 7776 -> (2^13 = 8192) -1 == 8191 or 0x00001111 11111111
	
	          // Create byte array and fill with N random numbers
	          var byteArray = new Uint8Array(bytes_needed);
	          crypt.getRandomValues(byteArray);
	
	          var p = (bytes_needed - 1) * 8;
	          for(var i = 0; i < bytes_needed; i++ ) {
	              rval += byteArray[i] * Math.pow(2, p);
	              p -= 8;
	          }
	
	          // Use & to apply the mask and reduce the number of recursive lookups
	          rval = rval & mask;
	
	          if (rval >= range) {
	              // Integer out of acceptable range
	              return random(min, max);
	          }
	          // Return an integer that falls within the range
	          return min + rval;
	      }
	      return function() {
	          var r = random(0, 1000000000) / 1000000000;
	          return r;
	      };
	  } else {
	      // From http://baagoe.com/en/RandomMusings/javascript/
	      // Johannes BaagÃ¸e <baagoe@baagoe.com>, 2010
	      function Mash() {
	          var n = 0xefc8249d;
	
	          var mash = function(data) {
	              data = data.toString();
	              for (var i = 0; i < data.length; i++) {
	                  n += data.charCodeAt(i);
	                  var h = 0.02519603282416938 * n;
	                  n = h >>> 0;
	                  h -= n;
	                  h *= n;
	                  n = h >>> 0;
	                  h -= n;
	                  n += h * 0x100000000; // 2^32
	              }
	              return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
	          };
	
	          mash.version = 'Mash 0.9';
	          return mash;
	      }
	
	      // From http://baagoe.com/en/RandomMusings/javascript/
	      function Alea() {
	          return (function(args) {
	              // Johannes BaagÃ¸e <baagoe@baagoe.com>, 2010
	              var s0 = 0;
	              var s1 = 0;
	              var s2 = 0;
	              var c = 1;
	
	              if (args.length == 0) {
	                  args = [+new Date()];
	              }
	              var mash = Mash();
	              s0 = mash(' ');
	              s1 = mash(' ');
	              s2 = mash(' ');
	
	              for (var i = 0; i < args.length; i++) {
	                  s0 -= mash(args[i]);
	                  if (s0 < 0) {
	                      s0 += 1;
	                  }
	                  s1 -= mash(args[i]);
	                  if (s1 < 0) {
	                      s1 += 1;
	                  }
	                  s2 -= mash(args[i]);
	                  if (s2 < 0) {
	                      s2 += 1;
	                  }
	              }
	              mash = null;
	
	              var random = function() {
	                  var t = 2091639 * s0 + c * 2.3283064365386963e-10; // 2^-32
	                  s0 = s1;
	                  s1 = s2;
	                  return s2 = t - (c = t | 0);
	              };
	              random.uint32 = function() {
	                  return random() * 0x100000000; // 2^32
	              };
	              random.fract53 = function() {
	                  return random() +
	                      (random() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
	              };
	              random.version = 'Alea 0.9';
	              random.args = args;
	              return random;
	
	          }(Array.prototype.slice.call(arguments)));
	      };
	      return Alea(  window.performance && window.performance.now && window.performance.now() );
	  }
	}());
	
	var guid = function() {
	    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c)    {
	      var r = trueRandom() * 16 | 0,
	          v = c == 'x' ? r : (r & 0x3 | 0x8);
	      return v.toString(16);
	  });
	};
	
	var funnelUid = function(instanceId) {
	  var crypt = window.crypto || window.msCrypto || {
	    getRandomValues: function(buffer){
	      for(var i = 0; i < buffer.length; i++){
	        buffer[i] = Math.floor(Math.random() * Math.pow(2, buffer.BYTES_PER_ELEMENT * 8));
	      }
	
	      return buffer;
	    }
	  }
	
	  function random() {
	    var value = new Uint32Array(1);
	
	    crypt.getRandomValues(value);
	
	    return value[0];
	  }
	
	  function reverseBytes(value) {
	    return (((value & 0xFF) << 24 >>> 0) | ((value & 0xFF00) << 8 >>> 0) | ((value >>> 8) & 0xFF00 >>> 0) | ((value >>> 24) & 0xFF >>> 0)) >>> 0;
	  }
	
	  function now() {
	    return Math.floor(Date.now() / 1000);
	  }
	
	  function toBase64(buffer) {
	    var bytes  = new Uint8Array(buffer),
	        binary = '';
	
	    for(var i = 0; i < bytes.byteLength; i++){
	      binary += String.fromCharCode(bytes[i]);
	    }
	
	    return btoa(binary);
	  }
	
	  function userId(id) {
	    var id        = id.split('-'),
	        node      = parseInt(id[0], 36),
	        node_s    = Math.floor(node / 1000),
	        node_ms   = node % 1000,
	        version   = parseInt(id[1], 36),
	        timestamp = now(),
	        rand      = random(),
	        uid       = new Uint32Array(4);
	
	    // 1 - node, 2 - timestamp, 3 - version, 4 - random
	    // 11111111111111111111111111111111222222222222222222222222222222223333333333333333333333333333333344444444444444444444441111111111
	
	    uid[0] = reverseBytes(node_s);
	    uid[1] = reverseBytes(timestamp);
	    uid[2] = reverseBytes(version);
	    uid[3] = reverseBytes(((rand & 0xFFFFFC00) >>> 0) + node_ms);
	
	    return toBase64(uid.buffer);
	  }
	
	  return userId(instanceId);
	}
	
	module.exports = {
	  guid: guid,
	  funnelUid: funnelUid
	};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var cors = __webpack_require__(6);
	var debug = __webpack_require__(7);
	var object = __webpack_require__(11);
	var date = __webpack_require__(12);
	var prefixedCookies = __webpack_require__(8)('_hcfnl_');
	var frontendVersion = __webpack_require__(14)();
	
	
	var Transport = function(url) {
	  this.url = url;
	};
	
	Transport.isQueuedMode = true;
	Transport.urlPrefix = '//ostrovok.ru/hc';
	Transport.req_id = 0;
	Transport.ver = ("000000");
	Transport.frontendVersion = frontendVersion.version;
	Transport.verbose = (false);
	
	Transport.queue = [];
	Transport.online = true;
	
	
	Transport.disableQueuedMode = function() {
	  Transport.isQueuedMode = false;
	};
	
	Transport.setUrlPrefix = function(prefix) {
	  debug.log('[transport] url prefix', prefix);
	  Transport.urlPrefix = prefix;
	};
	
	Transport.onlineStatusChanged = function(event) {
	  var online = !!navigator.onLine;
	
	  Transport.online = online;
	
	  if (online) {
	    Transport.dequeue();
	  };
	
	  debug.log('[transport online status]', online);
	};
	
	window.addEventListener('online',  Transport.onlineStatusChanged, false);
	window.addEventListener('offline', Transport.onlineStatusChanged, false);
	
	Transport.enqueue = function(url, query, post) {
	  Transport.queue.push([url, query, post]);
	
	  debug.log('[transport request enqueued]', [url, query, post], Transport.queue.length, Transport.online);
	};
	
	Transport.dequeue = function() {
	  debug.log('[transport dequeue]', Transport.queue);
	
	  while (Transport.queue.length) {
	    var request = Transport.queue.shift();
	
	    Transport.request(request[0], request[1], request[2]);
	  }
	};
	
	Transport.request = function(url, query, post) {
	  var beacon = navigator.sendBeacon && query.beacon === true;
	
	  if (debug.isEnabled()) {
	    debug.log('[transport]', url, query, post);
	  } else if (beacon) {
	    cors.send('beacon_post', url, JSON.stringify(post));
	  } else if (post) {
	    cors.send('post', url, JSON.stringify(post));
	  } else {
	    var img = new Image();
	    img.src = url;
	  }
	};
	
	Transport.prototype.setVerbose = function(enable) {
	  Transport.verbose = !!enable;
	
	  debug.log('[funnel] transport verbose-mode is ' + (Transport.verbose ? 'on' : 'off'));
	};
	
	Transport.prototype.encode = function(data) {
	  var arr = [];
	
	  for (var name in data) {
	    var value = name + '=';
	    if (!data.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var type = typeof data[name];
	
	    if (type == 'boolean') {
	      value += (data[name] ? '1' : '0');
	    }
	    // null, undefined, 'null', 'undefined'
	    else if (type == 'undefined' || data[name] == null || data[name] === '' || data[name] === 'null' || data[name] === 'undefined' ) {
	      continue;
	    }
	    else if (type == 'object') {
	      value += encodeURIComponent(JSON.stringify(data[name]));
	    }
	    else {
	      value += encodeURIComponent(data[name]);
	    }
	
	    arr.push(value);
	  }
	
	  return arr;
	};
	
	Transport.prototype.send = function(queryData, opt_postData) {
	  var now = new Date();
	
	  ++Transport.req_id;
	
	  var post = null;
	  if (opt_postData !== null && typeof opt_postData === 'object' && Object.keys(opt_postData).length !== 0) {
	    post = opt_postData;
	  }
	
	  var query = queryData || {};
	
	  if (post && !cors.hasSupport()) {
	    query = object.assign({}, queryData, post);
	    post = null;
	  }
	
	  var queryString = ''
	    + '?req_id=' + Transport.req_id
	    + '&ver=' + Transport.ver
	    + '&fpr=' + prefixedCookies.get('fpr')
	    + '&ota_http_request_id=' + (window.ota_http_request_id || '')
	    + '&frontend_version=' + Transport.frontendVersion
	    + '&timesend=' + now.valueOf()
	    + '&user_time=' + encodeURIComponent(date.toLocalISOString(now))
	    + (query ? '&' + this.encode(query).join('&') : '')
	    // mark all requests from queue,
	    // because it may contains sideeffects
	    + (Transport.isQueuedMode ? '&_from_queue=1' : '')
	    + (!Transport.online ? '&_from_offline_queue=1' : '')
	    + (Transport.verbose ? '&verbose=1' : '');
	
	  var url = Transport.urlPrefix + this.url + queryString;
	
	  this.pushToDataLayer(query);
	
	  if (Transport.online) {
	    Transport.request(url, query, post);
	  } else {
	    Transport.enqueue(url, query, post);
	  }
	};
	
	Transport.prototype.pushToDataLayer = function(data) {
	  var endpoint = this.url.substring(1);
	  var event;
	
	  if (endpoint === 'funnel_v2') {
	    event = {event: 'funnel.hit'};
	  } else if (endpoint === 'event') {
	    event = {event: 'funnel.event'};
	  } else {
	    return;
	  }
	
	  event['funnel.context'] = data;
	
	  var dataLayer = (window.dataLayer = window.dataLayer || []);
	
	  dataLayer.push(event);
	
	  debug.log('[funnel] transport push to dataLayer', event);
	}
	
	module.exports = Transport;


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	var SupportMode = {
	  XHR: 1,
	  XDR: 2,
	  BCN: 4,
	  NONE: 3
	};
	
	var support = SupportMode.NONE;
	if (window.XMLHttpRequest) {
	  var request = new XMLHttpRequest();
	  if('withCredentials' in request) {
	    support = SupportMode.XHR;
	  } else if (window.XDomainRequest) {
	    support = SupportMode.XDR;
	  }
	  request = null;
	}
	
	module.exports.hasSupport = function() {
	  return support !== SupportMode.NONE;
	};
	
	module.exports.send = function(method, url, opt_data) {
	  var mode = method === 'beacon_post' ? SupportMode.BCN : support;
	
	  switch (mode) {
	    case SupportMode.XHR:
	      var request = new XMLHttpRequest();
	      request.open(method, url, true);
	      request.withCredentials = true;
	      request.send(opt_data);
	      break;
	    case SupportMode.XDR:
	      var xdr = new XDomainRequest();
	      xdr.open(method, url);
	      xdr.send(opt_data);
	      break;
	    case SupportMode.BCN:
	      var enqueued = navigator.sendBeacon(url, opt_data);
	      if (!enqueued) {
	        module.exports.send('post', url, opt_data);
	      }
	      break;
	  }
	};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var prefixedCookies = __webpack_require__(8)('_hcfnl_');
	
	var debug = !!prefixedCookies.get('debug');
	
	module.exports = {
	  setEnabled: function(enable) {
	    debug = !!enable;
	  },
	  isEnabled: function() {
	    return debug;
	  },
	  log: function() {
	    if (debug) {
	      console.log.apply(null, arguments);
	    }
	  }
	}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var get = __webpack_require__(9);
	var set = __webpack_require__(10);
	
	module.exports = function(opt_prefix) {
	  var prefix = opt_prefix || '';
	  return {
	    get: function(name) {
	      return get(prefix + name);
	    },
	    set: function(name, value, time) {
	      set(prefix + name, value, time);
	    },
	    del: function(name) {
	      set(prefix + name, 0, 0);
	    },
	    fullName: function(name) {
	      return prefix + name
	    }
	  };
	};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';
	
	var value;
	
	module.exports = function(name) {
	  value = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
	  return value ? value.pop() : '';
	};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(name, value, opt_time) {
	  var date = new Date(+new Date() + (opt_time || 31536000000));
	  document.cookie = [
	    name +'=' + value,
	    'expires=' + date.toUTCString(),
	    'path=/'
	  ].join('; ');
	};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	module.exports.assign = function(target) {
	  if (Object.assign) {
	    return Object.assign.apply(null, arguments);
	  }
	
	  if (target == null) {
	    throw new TypeError('Cannot convert undefined or null to object');
	  }
	
	  target = Object(target);
	  for (var index = 1; index < arguments.length; index++) {
	    var source = arguments[index];
	    if (source != null) {
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	  }
	  return target;
	};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var math = __webpack_require__(13);
	
	var toISOString = Date.prototype.toISOString;
	if (!toISOString) {
	  toISOString = function() {
	    return this.getUTCFullYear()
	        + '-' + math.pad(this.getUTCMonth() + 1)
	        + '-' + math.pad(this.getUTCDate())
	        + 'T' + math.pad(this.getUTCHours())
	        + ':' + math.pad(this.getUTCMinutes())
	        + ':' + math.pad(this.getUTCSeconds())
	        + '.' + String((this.getUTCMilliseconds()/1000).toFixed(3)).slice(2, 5);
	        + 'Z';
	  };
	}
	
	module.exports = {
	  toISOString: function(date) {
	    return toISOString.call(date);
	  },
	  toLocalISOString: function(date) {
	    var offset = date.getTimezoneOffset();
	    date = new Date(date - offset * 60000);
	    var isoString = toISOString.call(date);
	    var sign = math.sign(-offset);
	    var offset = Math.abs(offset)
	    return isoString.slice(0, -1) + sign +
	        math.pad(Math.floor(offset / 60)) + ':' + math.pad(offset % 60);
	  }
	};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	module.exports = {
	  pad: function(number) {
	    var r = String(number);
	    if ( r.length === 1 ) {
	        r = '0' + r;
	    }
	    return r;
	  },
	  sign: function(number) {
	    return number < 0 ? '-' : '+'
	  }
	};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	module.exports = function() {
	  if(window.ota_singlepage_version) {
	    return {
	      version: window.ota_singlepage_version,
	      platform: 'singlepage'
	    }
	  }
	  else if(window.SINGLEPAGE_CONFIG && window.SINGLEPAGE_CONFIG.SINGLEPAGE_VERSION) {
	    return {
	      version: window.SINGLEPAGE_CONFIG.SINGLEPAGE_VERSION,
	      platform: 'extranet'
	    }
	  }
	  return {
	    version: '',
	    platform: ''
	  }
	};
	
	
	


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  listen: function(node, e, fn) {
	    if (node.addEventListener) {
	      node.addEventListener(e, fn, false); 
	    } else if (node.attachEvent)  {
	      node.attachEvent('on' + e, fn);
	    }
	  },
	  unlisten: function(node, e, fn) {
	    if (node.removeEventListener) {
	      node.removeEventListener(e, fn, false); 
	    } else if (node.attachEvent)  {
	      node.detachEvent('on' + e, fn);
	    }
	  }
	};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(fn, ctx) {
	  if (fn.bind) {
	    return fn.bind(ctx);
	  }
	  return function() {
	    return fn.apply(ctx, arguments);
	  };
	};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	module.exports = {
	  viewportSize: function() {
	    var el = window.document.compatMode === 'CSS1Compat' ?
	        window.document.documentElement :
	        window.document.body;
	    return [el.clientWidth, el.clientHeight];
	  },
	  screenSize: function() {
	    return [window.screen.width, window.screen.height];
	  },
	  pixelRatio: function() {
	    return window.devicePixelRatio || (window.screen.deviceXDPI / window.screen.logicalXDPI) || 1;
	  }
	};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var userAgent = __webpack_require__(19);
	var events = __webpack_require__(15);
	var prefixedCookies = __webpack_require__(8)('_hcfnl_');
	var gecko = __webpack_require__(20);
	var trident = __webpack_require__(21);
	var webkit = __webpack_require__(22);
	
	var incognito = prefixedCookies.get('incognito');
	switch (incognito) {
	  case '1': incognito = true; break;
	  case '0': incognito = false; break;
	  default: incognito = null; break;
	}
	
	var setter = function(value) {
	  incognito = value;
	  prefixedCookies.set('incognito', value ? '1' : '0');
	};
	
	if (incognito === null) {
	  if (userAgent.webkit()) {
	    webkit(setter);
	  } else if (userAgent.gecko()) {
	    gecko(setter);
	  } else if (userAgent.trident()) {
	    trident(setter);
	  }
	}
	
	module.exports = function() {
	  return incognito;
	};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	var getUserAgent = function() {
	  if (window.navigator) {
	    return window.navigator.userAgent || '';
	  }
	  return '';
	};
	
	module.exports = {
	  _gecko: null,
	  _trident: null,
	  _webkit: null,
	  _mac: null,
	  userAgent: getUserAgent(),
	  match: function(str) {
	    return this.userAgent.indexOf(str) != -1
	  },
	  matchIgnoreCase: function(str) {
	    return this.userAgent.toLowerCase().indexOf(str.toLowerCase()) != -1
	  },
	  trident: function() {
	    if (this._trident === null) {
	      this._trident = this.match('Trident') && this.match('MSIE');
	    }
	    return this._trident;
	  },
	  webkit: function() {
	    if (this._webkit === null) {
	      this._webkit = this.matchIgnoreCase('WebKit');
	    }
	    return this._webkit;
	  },
	  gecko: function() {
	    if (this._gecko === null) {
	      this._gecko = this.match('Gecko') && !this.trident() && !this.webkit();
	    }
	    return this._gecko;
	  },
	  mac: function() {
	    if (this._mac === null) {
	      this._mac = this.match('Macintosh');
	    }
	    return this._mac;
	  },
	};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	module.exports = function(cb) {
	  if (window.indexedDB) {
	    try {
	      var request = window.indexedDB.open('test');
	      request.onerror = function (evt) {
	        if (request.error) {
	          evt.preventDefault();
	          cb(request.error.name === 'InvalidStateError');
	        }
	      };
	      request.onsuccess = function () {
	        cb(false);
	      };
	    } catch (e) {
	      cb(false);
	    }
	  }
	};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var userAgent = __webpack_require__(19);
	
	var docMode = function() {
	  return document ? document.documentMode : undefined;
	};
	
	var version = function() {
	  var re = /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/;
	  var arr = re.exec(userAgent.userAgent);
	  var v = arr ? arr[1] : '';
	
	  var mode = docMode();
	  if (mode > parseFloat(version)) {
	    return String(mode);
	  }
	
	  return v;
	};
	
	module.exports = function(cb) {
	  if (version() >= 10) {
	    try {
	      if (!window.indexedDB) {
	        cb(true);
	      } else {
	        cb(false);
	      }
	    } catch (ex) {
	      cb(false);
	    }
	  }
	};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var userAgent = __webpack_require__(19);
	
	module.exports = function(cb) {
	  var wrapper = function(value) {
	    return function() {
	      cb(value);
	    };
	  };
	
	  var fs = window.RequestFileSystem || window.webkitRequestFileSystem;
	  if (fs) {
	    fs(window.TEMPORARY, 100, wrapper(false), wrapper(true));
	  } else if (userAgent.match('Safari')) {
	    try {
	      window.localStorage.setItem('test', 1);
	      cb(false);
	      window.localStorage.removeItem('test');
	    } catch(ex) {
	      cb(true);
	    }
	  }
	};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var object = __webpack_require__(11);
	var Transport = __webpack_require__(5);
	var Event = __webpack_require__(24);
	var dom = __webpack_require__(25);
	var hash = __webpack_require__(4);
	
	var transport = new Transport('/action_tracker');
	
	module.exports = function(domainUid, jsHitId, intention, eventData, opt_context, opt_lastReq, instance_id) {
	  if (!intention) {
	    throw new Error('Bad intention: ' + intention);
	  }
	
	  var now = new Date();
	  var event = new Event(eventData);
	  var action = {
	    'context': opt_context || null,
	    'event': {
	      'is_custom': event.isCustomEvent,
	      'type': event.getType(),
	      'offsetX': event.offsetX,
	      'offsetY': event.offsetY,
	      'clientX': event.clientX,
	      'clientY': event.clientY,
	      'screenX': event.screenX,
	      'screenY': event.screenY,
	      'button': event.button,
	      'target_path': dom.getPath(event.target, event.currentTarget),
	    },
	    'intention': intention,
	    'viewport': {
	      'scroll': dom.getViewportScroll(),
	      'size': dom.getViewportSize(),
	    },
	    'domain_uid': domainUid,
	    'js_hit_id': jsHitId,
	    'action_id': hash.guid(),
	    'pagetype': opt_lastReq && opt_lastReq.pagetype || null
	  };
	  transport.send({
	    'action_id': action['action_id'],
	    'domain_uid': domainUid,
	    'js_hit_id': jsHitId,
	    'funnel_instance_id': instance_id
	  }, action);
	};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var userAgent = __webpack_require__(19);
	
	/**
	 * @param {string|Object|Event} event
	 */
	var Event = function(event) {
	  /**
	   * @type {boolean}
	   */
	  this.isCustomEvent = false;
	
	  /**
	   * The browser event object.
	   * type {Event}
	   */
	  this.originalEvent = null;
	
	  /**
	   * Target that fired the event.
	   * @type {Node}
	   */
	  this.target = null;
	
	  /**
	   * Event type.
	   * @type {string}
	   */
	  this.type = '';
	
	  /**
	   * Event type.
	   * @type {string}
	   */
	  this.forcedType = '';
	
	  /**
	   * Node that had the listener attached.
	   * @type {Node|undefined}
	   */
	  this.currentTarget = null;
	
	  /**
	   * For mouseover and mouseout events, the related object for the event.
	   * @type {Node}
	   */
	  this.relatedTarget = null;
	
	  /**
	   * X-coordinate relative to target.
	   * @type {number}
	   */
	  this.offsetX = 0;
	
	  /**
	   * Y-coordinate relative to target.
	   * @type {number}
	   */
	  this.offsetY = 0;
	
	  /**
	   * X-coordinate relative to the window.
	   * @type {number}
	   */
	  this.clientX = 0;
	
	  /**
	   * Y-coordinate relative to the window.
	   * @type {number}
	   */
	  this.clientY = 0;
	
	  /**
	   * X-coordinate relative to the monitor.
	   * @type {number}
	   */
	  this.screenX = 0;
	
	  /**
	   * Y-coordinate relative to the monitor.
	   * @type {number}
	   */
	  this.screenY = 0;
	
	  /**
	   * Which mouse button was pressed.
	   * @type {number}
	   */
	  this.button = 0;
	
	  /**
	   * Keycode of key press.
	   * @type {number}
	   */
	  this.keyCode = 0;
	
	  /**
	   * Keycode of key press.
	   * @type {number}
	   */
	  this.charCode = 0;
	
	  /**
	   * Whether control was pressed at time of event.
	   * @type {boolean}
	   */
	  this.ctrlKey = false;
	
	  /**
	   * Whether alt was pressed at time of event.
	   * @type {boolean}
	   */
	  this.altKey = false;
	
	  /**
	   * Whether shift was pressed at time of event.
	   * @type {boolean}
	   */
	  this.shiftKey = false;
	
	  /**
	   * Whether the meta key was pressed at time of event.
	   * @type {boolean}
	   */
	  this.metaKey = false;
	
	  /**
	   * History state object, only set for PopState events where it's a copy of the
	   * state object provided to pushState or replaceState.
	   * @type {Object}
	   */
	  this.state = null;
	
	  /**
	   * Whether the default platform modifier key was pressed at time of event.
	   * (This is control for all platforms except Mac, where it's Meta.)
	   * @type {boolean}
	   */
	  this.platformModifierKey = false;
	
	  this._init(event);
	};
	
	Event.prototype.hasForcedType = function() {
	  return this.type !== this.forcedType;
	};
	
	Event.prototype.getType = function() {
	  return this.forcedType || this.type;
	};
	
	Event.prototype._init = function init(e, opt_type) {
	  // TODO(max.nikitin@): dirtyhack. `instanceof Event` doesnt work
	  if (e.preventDefault) {
	    var relevantTouch = e.changedTouches ? e.changedTouches[0] : null;
	
	    this.originalEvent = e;
	    this.type = e.type;
	    this.target = /** @type {Node} */ (e.target) || e.srcElement;
	    this.currentTarget = /** @type {Node} */ (e.currentTarget || e.target);
	
	    var relatedTarget = /** @type {Node} */ (e.relatedTarget);
	    if (!relatedTarget) {
	      if (this.type.indexOf('mouseover') !== -1) {
	        relatedTarget = e.fromElement;
	      } else if (this.type.indexOf('mouseout') !== -1) {
	        relatedTarget = e.toElement;
	      }
	    }
	
	    this.relatedTarget = relatedTarget;
	
	    if (relevantTouch != null) {
	      this.clientX = relevantTouch.clientX !== undefined ? relevantTouch.clientX : relevantTouch.pageX;
	      this.clientY = relevantTouch.clientY !== undefined ? relevantTouch.clientY : relevantTouch.pageY;
	      this.screenX = relevantTouch.screenX || 0;
	      this.screenY = relevantTouch.screenY || 0;
	    } else {
	      // Webkit emits a lame warning whenever layerX/layerY is accessed.
	      // http://code.google.com/p/chromium/issues/detail?id=101733
	      this.offsetX = e.offsetX !== undefined ? e.offsetX : e.layerX;
	      this.offsetY = e.offsetY !== undefined ? e.offsetY : e.layerY;
	      this.clientX = e.clientX !== undefined ? e.clientX : e.pageX;
	      this.clientY = e.clientY !== undefined ? e.clientY : e.pageY;
	      this.screenX = e.screenX || 0;
	      this.screenY = e.screenY || 0;
	    }
	
	    this.button = e.button;
	    this.keyCode = e.keyCode || 0;
	    this.charCode = e.charCode || (this.type == 'keypress' ? e.keyCode : 0);
	    this.ctrlKey = e.ctrlKey;
	    this.altKey = e.altKey;
	    this.shiftKey = e.shiftKey;
	    this.metaKey = e.metaKey;
	    this.platformModifierKey = userAgent.mac() ? e.metaKey : e.ctrlKey;
	    this.state = e.state;
	    this.isCustomEvent = false;
	  } else if (typeof e === 'object') {
	    if (e.type && e.event) {
	      return init.call(this, e.event, e.type);
	    }
	    this.type = opt_type || e.type;
	    this.target = e.target || null;
	    this.currentTarget = e.currentTarget || e.target || null;
	    this.relatedTarget = e.relatedTarget || null;
	    this.isCustomEvent = true;
	  } else if (typeof e === 'string') {
	    this.type = e;
	  } else {
	    throw new Error('Bad data for event init: ' + e);
	  }
	
	  this.forcedType = opt_type || this.type;
	
	  if (!this.type || typeof this.type !== 'string') {
	    throw new Error('Bad event type: ' + this.type);
	  }
	}
	
	module.exports = Event;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var userAgent = __webpack_require__(19);
	
	var NodeTypes = [
	  'ELEMENT_NODE',
	  'ATTRIBUTE_NODE',
	  'TEXT_NODE',
	  'CDATA_SECTION_NODE',
	  'ENTITY_REFERENCE_NODE',
	  'ENTITY_NODE',
	  'PROCESSING_INSTRUCTION_NODE',
	  'COMMENT_NODE',
	  'DOCUMENT_NODE',
	  'DOCUMENT_TYPE_NODE',
	  'DOCUMENT_FRAGMENT_NODE',
	  'NOTATION_NODE'
	];
	
	module.exports.getPath = function(node, currentTarget) {
	  if (!node) {
	    return null;
	  }
	
	  var path = [getNodeSignature(node, currentTarget)];
	  while (node = node.parentNode) {
	    path.push(getNodeSignature(node, currentTarget));
	  }
	  return path;
	};
	
	module.exports.getViewportSize = function() {
	  var element = document.compatMode == 'CSS1Compat' ?
	      document.documentElement :
	      document.body;
	  return {
	    'width': element.clientWidth,
	    'height': element.clientHeight
	  };
	};
	
	module.exports.getViewportScroll = function() {
	  var element = getDocumentScrollElement();
	  return {
	    'left': element.scrollLeft,
	    'top': element.scrollTop
	  };
	};
	
	function getNodeSignature(node, currentTarget) {
	  var nodeType = NodeTypes[node.nodeType - 1] || node.nodeType;
	  var result = {};
	  if (node === currentTarget) {
	    result['is_current_target'] = true;
	  }
	
	  if (nodeType === 'ELEMENT_NODE') {
	    var tagName = node.tagName.toLowerCase();
	    var classNames = getClassNames(node);
	    if (classNames.length > 0) {
	      result['classNames'] = classNames;
	    }
	    if (node.id) {
	      result['id'] = node.id;
	    }
	    result['tagName'] = tagName;
	    switch (tagName) {
	      case 'input':
	        result['name'] = node.name;
	        result['type'] = node.type;
	        if (node.type === 'radio' || node.type === 'checkbox') {
	          result['checked'] = node.checked;
	        }
	        if (node.type === 'password' || node.hasAttribute('data-funnel-hidden')) {
	          result['valueTrimmed50'] = '[hidden]';
	        } else {
	          result['valueTrimmed50'] = trim(node.value, 50);
	        }
	        break;
	      case 'select':
	      case 'textarea':
	        result['name'] = node.name;
	        result['valueTrimmed50'] = trim(node.value, 50);
	        break;
	      case 'form':
	        result['action'] = node.action;
	        result['method'] = node.method;
	        break;
	      case 'a':
	      case 'span':
	      case 'button':
	      case 'div':
	        if (node === currentTarget) {
	          var textContent = node.textContent;
	          if (textContent) {
	            result['textContentTrimmed50'] = trim(textContent, 50);
	          }
	        }
	    }
	
	    return result;
	  }
	
	  result['nodeType'] = nodeType;
	  return result;
	};
	
	function trim(text, length) {
	  if (!text || text.length < length) {
	    return text;
	  }
	  return text.substr(0, Math.max(length - 3, 0)) + '...';
	}
	
	function getClassNames(element) {
	  var classNames = (element.getAttribute('class') || '');
	  return classNames.split(/\s+/).filter(function(className) {
	    return !!className;
	  });
	}
	
	function getDocumentScrollElement() {
	  if (document.scrollingElement) {
	    return document.scrollingElement;
	  }
	  if (!userAgent.webkit() && document.compatMode == 'CSS1Compat') {
	    return document.documentElement;
	  }
	  return document.body || document.documentElement;
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Transport = __webpack_require__(5);
	
	var getRequestData = function(displayType, action, displayId, unit, data) {
	  var request = {
	    display_type: displayType,
	    action: action,
	    display_id: displayId,
	    unit: unit
	  };
	
	  if (data && typeof data === 'object') {
	    for (var name in data) {
	      if (data.hasOwnProperty(name) && name !== 'content_raw') {
	        request[name] = data[name];
	      }
	    }
	  }
	
	  return request;
	};
	
	module.exports = function(funnel) {
	  var transport = new Transport('/block');
	
	  return function(displayType, action, displayId, unit, data) {
	    if (funnel._funnelWasSent) {
	      var req = getRequestData(displayType, action, displayId, unit, data);
	      var contentRaw = data && data.content_raw;
	
	      funnel.addRelations(req);
	      transport.debug = funnel.isDebug();
	
	      transport.send(req, contentRaw);
	    } else {
	      funnel._preSendQueue.push({
	        type: 'block',
	        display_type: displayType,
	        action: action,
	        display_id: displayId,
	        unit: unit,
	        data: data
	      });
	    }
	  };
	};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Transport = __webpack_require__(5);
	var object = __webpack_require__(11);
	
	var getRequestData = function(category, action, opt_label, opt_data, opt_post_data, opt_options) {
	  var label = null;
	  var data = opt_data;
	  var options = null;
	
	  if (opt_label && typeof opt_label === 'object') {
	    data = opt_label;
	    options = opt_data;
	  } else {
	    label = opt_label || null;
	    options = opt_options || null;
	  }
	
	  var request = {
	    category: category,
	    action: action
	  };
	
	  if (label) {
	    request.label = label;
	  }
	
	  if (data && typeof data === 'object') {
	    request.data = object.assign({}, data);
	  }
	
	  if (options && typeof options === 'object') {
	    for (var name in options) {
	      if (options.hasOwnProperty(name)) {
	        request[name] = options[name];
	      }
	    }
	  }
	
	  return request;
	};
	
	module.exports = function(funnel) {
	  var transport = new Transport('/event');
	
	  return function(category, action, opt_label, opt_data, opt_post_data, opt_options) {
	    var force = opt_options && opt_options.force;
	
	    if (opt_label && typeof opt_label === 'object') {
	      force = opt_data && opt_data.force;
	    }
	
	    if (funnel._funnelWasSent || force) {
	      var req = getRequestData(category, action, opt_label, opt_data, opt_post_data, opt_options);
	
	      funnel.addRelations(req);
	      transport.debug = funnel.isDebug();
	
	      transport.send(req, opt_post_data);
	    } else {
	      funnel._preSendQueue.push({
	        type: 'event',
	        category: category,
	        action: action,
	        opt_label: opt_label,
	        opt_data: opt_data,
	        opt_post_data: opt_post_data,
	        opt_options: opt_options
	      });
	    }
	  };
	};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Transport = __webpack_require__(5);
	
	module.exports = function(funnel) {
	  var transport = new Transport('/displays');
	
	  return function(opt_data) {
	    if (funnel._funnelWasSent) {
	      var req = opt_data || {};
	
	      req.url = document.location.href;
	      funnel.addRelations(req);
	      transport.debug = funnel.isDebug();
	
	      transport.send(req);
	    } else {
	      funnel._preSendQueue.push({
	        type: 'display',
	        opt_data: opt_data
	      });
	    }
	  };
	};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var cookies = __webpack_require__(8)();
	var Transport = __webpack_require__(5);
	var strFunc = __webpack_require__(30);
	var object = __webpack_require__(11);
	var fpr = __webpack_require__(31);
	var prefixedCookies = __webpack_require__(8)('_hcfnl_');
	
	var listOfCookie = [
	  // ostrovok user id
	  'userid',
	  // ostrovok client user id
	  prefixedCookies.fullName('funnel_uid'),
	  // dynamic yield visitor id
	  '_dyid',
	  // domain visitor id (set on balancer)
	  'uid',
	  // Google analytics visitor id
	  '_ga',
	  // yandex metrica visitor id
	  '_ym_uid',
	  // exponea id
	  '__exponea_etc__',
	  // fingerprint
	  prefixedCookies.fullName('fpr')
	]
	
	var req = {
	  domain: document.location.hostname
	  // cookie name: value, ..
	};
	
	function identify (call_sync) {
	  var cookie_name = 'fpr';
	
	  if (!prefixedCookies.get(cookie_name)) {
	    var fpr_opt = {
	      excludes: {
	        timezoneOffset: true
	      },
	      audio: {
	        timeout: 3000
	      }
	    };
	
	    try {
	      fpr.get(fpr_opt, function(components) {
	        var values = components.map(function (component) {
	          return component.value;
	        });
	        var murmur = fpr.x64hash128(values.join(''), 31);
	        prefixedCookies.set(cookie_name, murmur);
	
	        sync();
	      });
	    } catch (e) {
	      window.hcfunnel('event', 'tracking', 'funnel', 'fpr_error', {
	        name: e.name,
	        stack: e.stack,
	        message: e.message
	      });
	
	      sync();
	    }
	  }
	}
	
	// create and sign cookie list
	function getCookieList (listOfCookie) {
	  var str = '',
	      list = {};
	
	  listOfCookie = listOfCookie.sort();
	
	  for(var i = 0; i < listOfCookie.length; i++) {
	    var name = listOfCookie[i],
	        value = cookies.get(name) || '';
	
	    list[name] = value;
	    str += '|' + name + '=' + value;
	  }
	
	  var hash = strFunc.hashCode(str);
	
	  return [hash, list];
	}
	
	// send if it changed
	function sync () {
	  var cookieList = getCookieList(listOfCookie),
	      cookieName = 'csync_h';
	
	  var oldSign = prefixedCookies.get(cookieName);
	  var newSign = cookieList[0];
	
	  if (oldSign != newSign) {
	    (new Transport('/csync')).send(object.assign(req, cookieList[1]));
	    prefixedCookies.set(cookieName, newSign, 86400 * 30 * 1000);
	  }
	}
	
	module.exports = {
	  once: sync,
	  periodically: function() {
	    setInterval(sync, 10 * 60 * 1000);
	  },
	  identify: identify
	};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

	'use strict';
	
	var padLeft = function(string, paddingValue) {
	  return String(paddingValue + string).slice(string.length);
	};
	
	/**
	 * @see http://stackoverflow.com/q/7616461/940217
	 * @return {number}
	 */
	var hashCode = function(str){
	  if (Array.prototype.reduce){
	    return str.split("").reduce(function(a,b){
	      a = ((a << 5) - a) + b.charCodeAt(0);
	      return a & a
	    }, 0);
	  } 
	  var hash = 0;
	  if (str.length === 0) return hash;
	  for (var i = 0; i < str.length; i++) {
	    var character  = str.charCodeAt(i);
	    hash  = ((hash<<5)-hash)+character;
	    hash = hash & hash; // Convert to 32bit integer
	  }
	  return hash;
	}
	
	module.exports = {
	  padLeft: padLeft,
	  hashCode: hashCode
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	* Fingerprintjs2 2.0.5 - Modern & flexible browser fingerprint library v2
	* https://github.com/Valve/fingerprintjs2
	* Copyright (c) 2015 Valentin Vasilyev (valentin.vasilyev@outlook.com)
	* Licensed under the MIT (http://www.opensource.org/licenses/mit-license.php) license.
	*
	* THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	* AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	* IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
	* ARE DISCLAIMED. IN NO EVENT SHALL VALENTIN VASILYEV BE LIABLE FOR ANY
	* DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
	* (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
	* LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
	* ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	* (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
	* THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	/* global define */
	(function (name, context, definition) {
	  'use strict'
	  if (typeof window !== 'undefined' && "function" === 'function' && __webpack_require__(32)) { !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) } else if (typeof module !== 'undefined' && module.exports) { module.exports = definition() } else if (context.exports) { context.exports = definition() } else { context[name] = definition() }
	})('Fingerprint2', this, function () {
	  'use strict'
	
	/// MurmurHash3 related functions
	
	//
	// Given two 64bit ints (as an array of two 32bit ints) returns the two
	// added together as a 64bit int (as an array of two 32bit ints).
	//
	  var x64Add = function (m, n) {
	    m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff]
	    n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff]
	    var o = [0, 0, 0, 0]
	    o[3] += m[3] + n[3]
	    o[2] += o[3] >>> 16
	    o[3] &= 0xffff
	    o[2] += m[2] + n[2]
	    o[1] += o[2] >>> 16
	    o[2] &= 0xffff
	    o[1] += m[1] + n[1]
	    o[0] += o[1] >>> 16
	    o[1] &= 0xffff
	    o[0] += m[0] + n[0]
	    o[0] &= 0xffff
	    return [(o[0] << 16) | o[1], (o[2] << 16) | o[3]]
	  }
	
	//
	// Given two 64bit ints (as an array of two 32bit ints) returns the two
	// multiplied together as a 64bit int (as an array of two 32bit ints).
	//
	  var x64Multiply = function (m, n) {
	    m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff]
	    n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff]
	    var o = [0, 0, 0, 0]
	    o[3] += m[3] * n[3]
	    o[2] += o[3] >>> 16
	    o[3] &= 0xffff
	    o[2] += m[2] * n[3]
	    o[1] += o[2] >>> 16
	    o[2] &= 0xffff
	    o[2] += m[3] * n[2]
	    o[1] += o[2] >>> 16
	    o[2] &= 0xffff
	    o[1] += m[1] * n[3]
	    o[0] += o[1] >>> 16
	    o[1] &= 0xffff
	    o[1] += m[2] * n[2]
	    o[0] += o[1] >>> 16
	    o[1] &= 0xffff
	    o[1] += m[3] * n[1]
	    o[0] += o[1] >>> 16
	    o[1] &= 0xffff
	    o[0] += (m[0] * n[3]) + (m[1] * n[2]) + (m[2] * n[1]) + (m[3] * n[0])
	    o[0] &= 0xffff
	    return [(o[0] << 16) | o[1], (o[2] << 16) | o[3]]
	  }
	//
	// Given a 64bit int (as an array of two 32bit ints) and an int
	// representing a number of bit positions, returns the 64bit int (as an
	// array of two 32bit ints) rotated left by that number of positions.
	//
	  var x64Rotl = function (m, n) {
	    n %= 64
	    if (n === 32) {
	      return [m[1], m[0]]
	    } else if (n < 32) {
	      return [(m[0] << n) | (m[1] >>> (32 - n)), (m[1] << n) | (m[0] >>> (32 - n))]
	    } else {
	      n -= 32
	      return [(m[1] << n) | (m[0] >>> (32 - n)), (m[0] << n) | (m[1] >>> (32 - n))]
	    }
	  }
	//
	// Given a 64bit int (as an array of two 32bit ints) and an int
	// representing a number of bit positions, returns the 64bit int (as an
	// array of two 32bit ints) shifted left by that number of positions.
	//
	  var x64LeftShift = function (m, n) {
	    n %= 64
	    if (n === 0) {
	      return m
	    } else if (n < 32) {
	      return [(m[0] << n) | (m[1] >>> (32 - n)), m[1] << n]
	    } else {
	      return [m[1] << (n - 32), 0]
	    }
	  }
	//
	// Given two 64bit ints (as an array of two 32bit ints) returns the two
	// xored together as a 64bit int (as an array of two 32bit ints).
	//
	  var x64Xor = function (m, n) {
	    return [m[0] ^ n[0], m[1] ^ n[1]]
	  }
	//
	// Given a block, returns murmurHash3's final x64 mix of that block.
	// (`[0, h[0] >>> 1]` is a 33 bit unsigned right shift. This is the
	// only place where we need to right shift 64bit ints.)
	//
	  var x64Fmix = function (h) {
	    h = x64Xor(h, [0, h[0] >>> 1])
	    h = x64Multiply(h, [0xff51afd7, 0xed558ccd])
	    h = x64Xor(h, [0, h[0] >>> 1])
	    h = x64Multiply(h, [0xc4ceb9fe, 0x1a85ec53])
	    h = x64Xor(h, [0, h[0] >>> 1])
	    return h
	  }
	
	//
	// Given a string and an optional seed as an int, returns a 128 bit
	// hash using the x64 flavor of MurmurHash3, as an unsigned hex.
	//
	  var x64hash128 = function (key, seed) {
	    key = key || ''
	    seed = seed || 0
	    var remainder = key.length % 16
	    var bytes = key.length - remainder
	    var h1 = [0, seed]
	    var h2 = [0, seed]
	    var k1 = [0, 0]
	    var k2 = [0, 0]
	    var c1 = [0x87c37b91, 0x114253d5]
	    var c2 = [0x4cf5ad43, 0x2745937f]
	    for (var i = 0; i < bytes; i = i + 16) {
	      k1 = [((key.charCodeAt(i + 4) & 0xff)) | ((key.charCodeAt(i + 5) & 0xff) << 8) | ((key.charCodeAt(i + 6) & 0xff) << 16) | ((key.charCodeAt(i + 7) & 0xff) << 24), ((key.charCodeAt(i) & 0xff)) | ((key.charCodeAt(i + 1) & 0xff) << 8) | ((key.charCodeAt(i + 2) & 0xff) << 16) | ((key.charCodeAt(i + 3) & 0xff) << 24)]
	      k2 = [((key.charCodeAt(i + 12) & 0xff)) | ((key.charCodeAt(i + 13) & 0xff) << 8) | ((key.charCodeAt(i + 14) & 0xff) << 16) | ((key.charCodeAt(i + 15) & 0xff) << 24), ((key.charCodeAt(i + 8) & 0xff)) | ((key.charCodeAt(i + 9) & 0xff) << 8) | ((key.charCodeAt(i + 10) & 0xff) << 16) | ((key.charCodeAt(i + 11) & 0xff) << 24)]
	      k1 = x64Multiply(k1, c1)
	      k1 = x64Rotl(k1, 31)
	      k1 = x64Multiply(k1, c2)
	      h1 = x64Xor(h1, k1)
	      h1 = x64Rotl(h1, 27)
	      h1 = x64Add(h1, h2)
	      h1 = x64Add(x64Multiply(h1, [0, 5]), [0, 0x52dce729])
	      k2 = x64Multiply(k2, c2)
	      k2 = x64Rotl(k2, 33)
	      k2 = x64Multiply(k2, c1)
	      h2 = x64Xor(h2, k2)
	      h2 = x64Rotl(h2, 31)
	      h2 = x64Add(h2, h1)
	      h2 = x64Add(x64Multiply(h2, [0, 5]), [0, 0x38495ab5])
	    }
	    k1 = [0, 0]
	    k2 = [0, 0]
	    switch (remainder) {
	      case 15:
	        k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 14)], 48))
	      // fallthrough
	      case 14:
	        k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 13)], 40))
	      // fallthrough
	      case 13:
	        k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 12)], 32))
	      // fallthrough
	      case 12:
	        k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 11)], 24))
	      // fallthrough
	      case 11:
	        k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 10)], 16))
	      // fallthrough
	      case 10:
	        k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 9)], 8))
	      // fallthrough
	      case 9:
	        k2 = x64Xor(k2, [0, key.charCodeAt(i + 8)])
	        k2 = x64Multiply(k2, c2)
	        k2 = x64Rotl(k2, 33)
	        k2 = x64Multiply(k2, c1)
	        h2 = x64Xor(h2, k2)
	      // fallthrough
	      case 8:
	        k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 7)], 56))
	      // fallthrough
	      case 7:
	        k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 6)], 48))
	      // fallthrough
	      case 6:
	        k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 5)], 40))
	      // fallthrough
	      case 5:
	        k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 4)], 32))
	      // fallthrough
	      case 4:
	        k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 3)], 24))
	      // fallthrough
	      case 3:
	        k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 2)], 16))
	      // fallthrough
	      case 2:
	        k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 1)], 8))
	      // fallthrough
	      case 1:
	        k1 = x64Xor(k1, [0, key.charCodeAt(i)])
	        k1 = x64Multiply(k1, c1)
	        k1 = x64Rotl(k1, 31)
	        k1 = x64Multiply(k1, c2)
	        h1 = x64Xor(h1, k1)
	      // fallthrough
	    }
	    h1 = x64Xor(h1, [0, key.length])
	    h2 = x64Xor(h2, [0, key.length])
	    h1 = x64Add(h1, h2)
	    h2 = x64Add(h2, h1)
	    h1 = x64Fmix(h1)
	    h2 = x64Fmix(h2)
	    h1 = x64Add(h1, h2)
	    h2 = x64Add(h2, h1)
	    return ('00000000' + (h1[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (h1[1] >>> 0).toString(16)).slice(-8) + ('00000000' + (h2[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (h2[1] >>> 0).toString(16)).slice(-8)
	  }
	
	  var defaultOptions = {
	    preprocessor: null,
	    audio: {
	      timeout: 1000,
	        // On iOS 11, audio context can only be used in response to user interaction.
	        // We require users to explicitly enable audio fingerprinting on iOS 11.
	        // See https://stackoverflow.com/questions/46363048/onaudioprocess-not-called-on-ios11#46534088
	      excludeIOS11: true
	    },
	    fonts: {
	      swfContainerId: 'fingerprintjs2',
	      swfPath: 'flash/compiled/FontList.swf',
	      userDefinedFonts: [],
	      extendedJsFonts: false
	    },
	    screen: {
	       // To ensure consistent fingerprints when users rotate their mobile devices
	      detectScreenOrientation: true
	    },
	    plugins: {
	      sortPluginsFor: [/palemoon/i],
	      excludeIE: false
	    },
	    extraComponents: [],
	    excludes: {
	      // Unreliable on Windows, see https://github.com/Valve/fingerprintjs2/issues/375
	      'enumerateDevices': true,
	      // devicePixelRatio depends on browser zoom, and it's impossible to detect browser zoom
	      'pixelRatio': true,
	      // DNT depends on incognito mode for some browsers (Chrome) and it's impossible to detect incognito mode
	      'doNotTrack': true,
	      // uses js fonts already
	      'fontsFlash': true
	    },
	    NOT_AVAILABLE: 'not available',
	    ERROR: 'error',
	    EXCLUDED: 'excluded'
	  }
	
	  var each = function (obj, iterator) {
	    if (Array.prototype.forEach && obj.forEach === Array.prototype.forEach) {
	      obj.forEach(iterator)
	    } else if (obj.length === +obj.length) {
	      for (var i = 0, l = obj.length; i < l; i++) {
	        iterator(obj[i], i, obj)
	      }
	    } else {
	      for (var key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator(obj[key], key, obj)
	        }
	      }
	    }
	  }
	
	  var map = function (obj, iterator) {
	    var results = []
	    // Not using strict equality so that this acts as a
	    // shortcut to checking for `null` and `undefined`.
	    if (obj == null) {
	      return results
	    }
	    if (Array.prototype.map && obj.map === Array.prototype.map) { return obj.map(iterator) }
	    each(obj, function (value, index, list) {
	      results.push(iterator(value, index, list))
	    })
	    return results
	  }
	
	  var extendSoft = function (target, source) {
	    if (source == null) { return target }
	    var value
	    var key
	    for (key in source) {
	      value = source[key]
	      if (value != null && !(Object.prototype.hasOwnProperty.call(target, key))) {
	        target[key] = value
	      }
	    }
	    return target
	  }
	
	// https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/enumerateDevices
	  var enumerateDevicesKey = function (done, options) {
	    if (!isEnumerateDevicesSupported()) {
	      return done(options.NOT_AVAILABLE)
	    }
	    navigator.mediaDevices.enumerateDevices().then(function (devices) {
	      done(devices.map(function (device) {
	        return 'id=' + device.deviceId + ';gid=' + device.groupId + ';' + device.kind + ';' + device.label
	      }))
	    })
	      .catch(function (error) {
	        done(error)
	      })
	  }
	
	  var isEnumerateDevicesSupported = function () {
	    return (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices)
	  }
	// Inspired by and based on https://github.com/cozylife/audio-fingerprint
	  var audioKey = function (done, options) {
	    var audioOptions = options.audio
	    if (audioOptions.excludeIOS11 && navigator.userAgent.match(/OS 11.+Version\/11.+Safari/)) {
	        // See comment for excludeUserAgent and https://stackoverflow.com/questions/46363048/onaudioprocess-not-called-on-ios11#46534088
	      return done(options.EXCLUDED)
	    }
	
	    var AudioContext = window.OfflineAudioContext || window.webkitOfflineAudioContext
	
	    if (AudioContext == null) {
	      return done(options.NOT_AVAILABLE)
	    }
	
	    var context = new AudioContext(1, 44100, 44100)
	
	    var oscillator = context.createOscillator()
	    oscillator.type = 'triangle'
	    oscillator.frequency.setValueAtTime(10000, context.currentTime)
	
	    var compressor = context.createDynamicsCompressor()
	    each([
	        ['threshold', -50],
	        ['knee', 40],
	        ['ratio', 12],
	        ['reduction', -20],
	        ['attack', 0],
	        ['release', 0.25]
	    ], function (item) {
	      if (compressor[item[0]] !== undefined && typeof compressor[item[0]].setValueAtTime === 'function') {
	        compressor[item[0]].setValueAtTime(item[1], context.currentTime)
	      }
	    })
	
	    oscillator.connect(compressor)
	    compressor.connect(context.destination)
	    oscillator.start(0)
	    context.startRendering()
	
	    var audioTimeoutId = setTimeout(function () {
	      console.warn('Audio fingerprint timed out. Please report bug at https://github.com/Valve/fingerprintjs2 with your user agent: "' + navigator.userAgent + '".')
	      context.oncomplete = function () {}
	      context = null
	      return done('audioTimeout')
	    }, audioOptions.timeout)
	
	    context.oncomplete = function (event) {
	      var fingerprint
	      try {
	        clearTimeout(audioTimeoutId)
	        fingerprint = event.renderedBuffer.getChannelData(0)
	            .slice(4500, 5000)
	            .reduce(function (acc, val) { return acc + Math.abs(val) }, 0)
	            .toString()
	        oscillator.disconnect()
	        compressor.disconnect()
	      } catch (error) {
	        done(error)
	        return
	      }
	      done(fingerprint)
	    }
	  }
	  var UserAgent = function (done) {
	    done(navigator.userAgent)
	  }
	  var languageKey = function (done, options) {
	    done(navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || options.NOT_AVAILABLE)
	  }
	  var colorDepthKey = function (done, options) {
	    done(window.screen.colorDepth || options.NOT_AVAILABLE)
	  }
	  var deviceMemoryKey = function (done, options) {
	    done(navigator.deviceMemory || options.NOT_AVAILABLE)
	  }
	  var pixelRatioKey = function (done, options) {
	    done(window.devicePixelRatio || options.NOT_AVAILABLE)
	  }
	  var screenResolutionKey = function (done, options) {
	    done(getScreenResolution(options))
	  }
	  var getScreenResolution = function (options) {
	    var resolution = [window.screen.width, window.screen.height]
	    if (options.screen.detectScreenOrientation) {
	      resolution.sort().reverse()
	    }
	    return resolution
	  }
	  var availableScreenResolutionKey = function (done, options) {
	    done(getAvailableScreenResolution(options))
	  }
	  var getAvailableScreenResolution = function (options) {
	    if (window.screen.availWidth && window.screen.availHeight) {
	      var available = [window.screen.availHeight, window.screen.availWidth]
	      if (options.screen.detectScreenOrientation) {
	        available.sort().reverse()
	      }
	      return available
	    }
	    // headless browsers
	    return options.NOT_AVAILABLE
	  }
	  var timezoneOffset = function (done) {
	    done(new Date().getTimezoneOffset())
	  }
	  var timezone = function (done, options) {
	    if (window.Intl && window.Intl.DateTimeFormat) {
	      done(new window.Intl.DateTimeFormat().resolvedOptions().timeZone)
	      return
	    }
	    done(options.NOT_AVAILABLE)
	  }
	  var sessionStorageKey = function (done, options) {
	    done(hasSessionStorage(options))
	  }
	  var localStorageKey = function (done, options) {
	    done(hasLocalStorage(options))
	  }
	  var indexedDbKey = function (done, options) {
	    done(hasIndexedDB(options))
	  }
	  var addBehaviorKey = function (done) {
	      // body might not be defined at this point or removed programmatically
	    done(!!(document.body && document.body.addBehavior))
	  }
	  var openDatabaseKey = function (done) {
	    done(!!window.openDatabase)
	  }
	  var cpuClassKey = function (done, options) {
	    done(getNavigatorCpuClass(options))
	  }
	  var platformKey = function (done, options) {
	    done(getNavigatorPlatform(options))
	  }
	  var doNotTrackKey = function (done, options) {
	    done(getDoNotTrack(options))
	  }
	  var canvasKey = function (done, options) {
	    if (isCanvasSupported()) {
	      done(getCanvasFp(options))
	      return
	    }
	    done(options.NOT_AVAILABLE)
	  }
	  var webglKey = function (done, options) {
	    if (isWebGlSupported()) {
	      done(getWebglFp())
	      return
	    }
	    done(options.NOT_AVAILABLE)
	  }
	  var webglVendorAndRendererKey = function (done) {
	    if (isWebGlSupported()) {
	      done(getWebglVendorAndRenderer())
	      return
	    }
	    done()
	  }
	  var adBlockKey = function (done) {
	    done(getAdBlock())
	  }
	  var hasLiedLanguagesKey = function (done) {
	    done(getHasLiedLanguages())
	  }
	  var hasLiedResolutionKey = function (done) {
	    done(getHasLiedResolution())
	  }
	  var hasLiedOsKey = function (done) {
	    done(getHasLiedOs())
	  }
	  var hasLiedBrowserKey = function (done) {
	    done(getHasLiedBrowser())
	  }
	// flash fonts (will increase fingerprinting time 20X to ~ 130-150ms)
	  var flashFontsKey = function (done, options) {
	    // we do flash if swfobject is loaded
	    if (!hasSwfObjectLoaded()) {
	      return done('swf object not loaded')
	    }
	    if (!hasMinFlashInstalled()) {
	      return done('flash not installed')
	    }
	    if (!options.fonts.swfPath) {
	      return done('missing options.fonts.swfPath')
	    }
	    loadSwfAndDetectFonts(function (fonts) {
	      done(fonts)
	    }, options)
	  }
	// kudos to http://www.lalit.org/lab/javascript-css-font-detect/
	  var jsFontsKey = function (done, options) {
	      // a font will be compared against all the three default fonts.
	      // and if it doesn't match all 3 then that font is not available.
	    var baseFonts = ['monospace', 'sans-serif', 'serif']
	
	    var fontList = [
	      'Andale Mono', 'Arial', 'Arial Black', 'Arial Hebrew', 'Arial MT', 'Arial Narrow', 'Arial Rounded MT Bold', 'Arial Unicode MS',
	      'Bitstream Vera Sans Mono', 'Book Antiqua', 'Bookman Old Style',
	      'Calibri', 'Cambria', 'Cambria Math', 'Century', 'Century Gothic', 'Century Schoolbook', 'Comic Sans', 'Comic Sans MS', 'Consolas', 'Courier', 'Courier New',
	      'Geneva', 'Georgia',
	      'Helvetica', 'Helvetica Neue',
	      'Impact',
	      'Lucida Bright', 'Lucida Calligraphy', 'Lucida Console', 'Lucida Fax', 'LUCIDA GRANDE', 'Lucida Handwriting', 'Lucida Sans', 'Lucida Sans Typewriter', 'Lucida Sans Unicode',
	      'Microsoft Sans Serif', 'Monaco', 'Monotype Corsiva', 'MS Gothic', 'MS Outlook', 'MS PGothic', 'MS Reference Sans Serif', 'MS Sans Serif', 'MS Serif', 'MYRIAD', 'MYRIAD PRO',
	      'Palatino', 'Palatino Linotype',
	      'Segoe Print', 'Segoe Script', 'Segoe UI', 'Segoe UI Light', 'Segoe UI Semibold', 'Segoe UI Symbol',
	      'Tahoma', 'Times', 'Times New Roman', 'Times New Roman PS', 'Trebuchet MS',
	      'Verdana', 'Wingdings', 'Wingdings 2', 'Wingdings 3'
	    ]
	
	    if (options.fonts.extendedJsFonts) {
	      var extendedFontList = [
	        'Abadi MT Condensed Light', 'Academy Engraved LET', 'ADOBE CASLON PRO', 'Adobe Garamond', 'ADOBE GARAMOND PRO', 'Agency FB', 'Aharoni', 'Albertus Extra Bold', 'Albertus Medium', 'Algerian', 'Amazone BT', 'American Typewriter',
	        'American Typewriter Condensed', 'AmerType Md BT', 'Andalus', 'Angsana New', 'AngsanaUPC', 'Antique Olive', 'Aparajita', 'Apple Chancery', 'Apple Color Emoji', 'Apple SD Gothic Neo', 'Arabic Typesetting', 'ARCHER',
	        'ARNO PRO', 'Arrus BT', 'Aurora Cn BT', 'AvantGarde Bk BT', 'AvantGarde Md BT', 'AVENIR', 'Ayuthaya', 'Bandy', 'Bangla Sangam MN', 'Bank Gothic', 'BankGothic Md BT', 'Baskerville',
	        'Baskerville Old Face', 'Batang', 'BatangChe', 'Bauer Bodoni', 'Bauhaus 93', 'Bazooka', 'Bell MT', 'Bembo', 'Benguiat Bk BT', 'Berlin Sans FB', 'Berlin Sans FB Demi', 'Bernard MT Condensed', 'BernhardFashion BT', 'BernhardMod BT', 'Big Caslon', 'BinnerD',
	        'Blackadder ITC', 'BlairMdITC TT', 'Bodoni 72', 'Bodoni 72 Oldstyle', 'Bodoni 72 Smallcaps', 'Bodoni MT', 'Bodoni MT Black', 'Bodoni MT Condensed', 'Bodoni MT Poster Compressed',
	        'Bookshelf Symbol 7', 'Boulder', 'Bradley Hand', 'Bradley Hand ITC', 'Bremen Bd BT', 'Britannic Bold', 'Broadway', 'Browallia New', 'BrowalliaUPC', 'Brush Script MT', 'Californian FB', 'Calisto MT', 'Calligrapher', 'Candara',
	        'CaslonOpnface BT', 'Castellar', 'Centaur', 'Cezanne', 'CG Omega', 'CG Times', 'Chalkboard', 'Chalkboard SE', 'Chalkduster', 'Charlesworth', 'Charter Bd BT', 'Charter BT', 'Chaucer',
	        'ChelthmITC Bk BT', 'Chiller', 'Clarendon', 'Clarendon Condensed', 'CloisterBlack BT', 'Cochin', 'Colonna MT', 'Constantia', 'Cooper Black', 'Copperplate', 'Copperplate Gothic', 'Copperplate Gothic Bold',
	        'Copperplate Gothic Light', 'CopperplGoth Bd BT', 'Corbel', 'Cordia New', 'CordiaUPC', 'Cornerstone', 'Coronet', 'Cuckoo', 'Curlz MT', 'DaunPenh', 'Dauphin', 'David', 'DB LCD Temp', 'DELICIOUS', 'Denmark',
	        'DFKai-SB', 'Didot', 'DilleniaUPC', 'DIN', 'DokChampa', 'Dotum', 'DotumChe', 'Ebrima', 'Edwardian Script ITC', 'Elephant', 'English 111 Vivace BT', 'Engravers MT', 'EngraversGothic BT', 'Eras Bold ITC', 'Eras Demi ITC', 'Eras Light ITC', 'Eras Medium ITC',
	        'EucrosiaUPC', 'Euphemia', 'Euphemia UCAS', 'EUROSTILE', 'Exotc350 Bd BT', 'FangSong', 'Felix Titling', 'Fixedsys', 'FONTIN', 'Footlight MT Light', 'Forte',
	        'FrankRuehl', 'Fransiscan', 'Freefrm721 Blk BT', 'FreesiaUPC', 'Freestyle Script', 'French Script MT', 'FrnkGothITC Bk BT', 'Fruitger', 'FRUTIGER',
	        'Futura', 'Futura Bk BT', 'Futura Lt BT', 'Futura Md BT', 'Futura ZBlk BT', 'FuturaBlack BT', 'Gabriola', 'Galliard BT', 'Gautami', 'Geeza Pro', 'Geometr231 BT', 'Geometr231 Hv BT', 'Geometr231 Lt BT', 'GeoSlab 703 Lt BT',
	        'GeoSlab 703 XBd BT', 'Gigi', 'Gill Sans', 'Gill Sans MT', 'Gill Sans MT Condensed', 'Gill Sans MT Ext Condensed Bold', 'Gill Sans Ultra Bold', 'Gill Sans Ultra Bold Condensed', 'Gisha', 'Gloucester MT Extra Condensed', 'GOTHAM', 'GOTHAM BOLD',
	        'Goudy Old Style', 'Goudy Stout', 'GoudyHandtooled BT', 'GoudyOLSt BT', 'Gujarati Sangam MN', 'Gulim', 'GulimChe', 'Gungsuh', 'GungsuhChe', 'Gurmukhi MN', 'Haettenschweiler', 'Harlow Solid Italic', 'Harrington', 'Heather', 'Heiti SC', 'Heiti TC', 'HELV',
	        'Herald', 'High Tower Text', 'Hiragino Kaku Gothic ProN', 'Hiragino Mincho ProN', 'Hoefler Text', 'Humanst 521 Cn BT', 'Humanst521 BT', 'Humanst521 Lt BT', 'Imprint MT Shadow', 'Incised901 Bd BT', 'Incised901 BT',
	        'Incised901 Lt BT', 'INCONSOLATA', 'Informal Roman', 'Informal011 BT', 'INTERSTATE', 'IrisUPC', 'Iskoola Pota', 'JasmineUPC', 'Jazz LET', 'Jenson', 'Jester', 'Jokerman', 'Juice ITC', 'Kabel Bk BT', 'Kabel Ult BT', 'Kailasa', 'KaiTi', 'Kalinga', 'Kannada Sangam MN',
	        'Kartika', 'Kaufmann Bd BT', 'Kaufmann BT', 'Khmer UI', 'KodchiangUPC', 'Kokila', 'Korinna BT', 'Kristen ITC', 'Krungthep', 'Kunstler Script', 'Lao UI', 'Latha', 'Leelawadee', 'Letter Gothic', 'Levenim MT', 'LilyUPC', 'Lithograph', 'Lithograph Light', 'Long Island',
	        'Lydian BT', 'Magneto', 'Maiandra GD', 'Malayalam Sangam MN', 'Malgun Gothic',
	        'Mangal', 'Marigold', 'Marion', 'Marker Felt', 'Market', 'Marlett', 'Matisse ITC', 'Matura MT Script Capitals', 'Meiryo', 'Meiryo UI', 'Microsoft Himalaya', 'Microsoft JhengHei', 'Microsoft New Tai Lue', 'Microsoft PhagsPa', 'Microsoft Tai Le',
	        'Microsoft Uighur', 'Microsoft YaHei', 'Microsoft Yi Baiti', 'MingLiU', 'MingLiU_HKSCS', 'MingLiU_HKSCS-ExtB', 'MingLiU-ExtB', 'Minion', 'Minion Pro', 'Miriam', 'Miriam Fixed', 'Mistral', 'Modern', 'Modern No. 20', 'Mona Lisa Solid ITC TT', 'Mongolian Baiti',
	        'MONO', 'MoolBoran', 'Mrs Eaves', 'MS LineDraw', 'MS Mincho', 'MS PMincho', 'MS Reference Specialty', 'MS UI Gothic', 'MT Extra', 'MUSEO', 'MV Boli',
	        'Nadeem', 'Narkisim', 'NEVIS', 'News Gothic', 'News GothicMT', 'NewsGoth BT', 'Niagara Engraved', 'Niagara Solid', 'Noteworthy', 'NSimSun', 'Nyala', 'OCR A Extended', 'Old Century', 'Old English Text MT', 'Onyx', 'Onyx BT', 'OPTIMA', 'Oriya Sangam MN',
	        'OSAKA', 'OzHandicraft BT', 'Palace Script MT', 'Papyrus', 'Parchment', 'Party LET', 'Pegasus', 'Perpetua', 'Perpetua Titling MT', 'PetitaBold', 'Pickwick', 'Plantagenet Cherokee', 'Playbill', 'PMingLiU', 'PMingLiU-ExtB',
	        'Poor Richard', 'Poster', 'PosterBodoni BT', 'PRINCETOWN LET', 'Pristina', 'PTBarnum BT', 'Pythagoras', 'Raavi', 'Rage Italic', 'Ravie', 'Ribbon131 Bd BT', 'Rockwell', 'Rockwell Condensed', 'Rockwell Extra Bold', 'Rod', 'Roman', 'Sakkal Majalla',
	        'Santa Fe LET', 'Savoye LET', 'Sceptre', 'Script', 'Script MT Bold', 'SCRIPTINA', 'Serifa', 'Serifa BT', 'Serifa Th BT', 'ShelleyVolante BT', 'Sherwood',
	        'Shonar Bangla', 'Showcard Gothic', 'Shruti', 'Signboard', 'SILKSCREEN', 'SimHei', 'Simplified Arabic', 'Simplified Arabic Fixed', 'SimSun', 'SimSun-ExtB', 'Sinhala Sangam MN', 'Sketch Rockwell', 'Skia', 'Small Fonts', 'Snap ITC', 'Snell Roundhand', 'Socket',
	        'Souvenir Lt BT', 'Staccato222 BT', 'Steamer', 'Stencil', 'Storybook', 'Styllo', 'Subway', 'Swis721 BlkEx BT', 'Swiss911 XCm BT', 'Sylfaen', 'Synchro LET', 'System', 'Tamil Sangam MN', 'Technical', 'Teletype', 'Telugu Sangam MN', 'Tempus Sans ITC',
	        'Terminal', 'Thonburi', 'Traditional Arabic', 'Trajan', 'TRAJAN PRO', 'Tristan', 'Tubular', 'Tunga', 'Tw Cen MT', 'Tw Cen MT Condensed', 'Tw Cen MT Condensed Extra Bold',
	        'TypoUpright BT', 'Unicorn', 'Univers', 'Univers CE 55 Medium', 'Univers Condensed', 'Utsaah', 'Vagabond', 'Vani', 'Vijaya', 'Viner Hand ITC', 'VisualUI', 'Vivaldi', 'Vladimir Script', 'Vrinda', 'Westminster', 'WHITNEY', 'Wide Latin',
	        'ZapfEllipt BT', 'ZapfHumnst BT', 'ZapfHumnst Dm BT', 'Zapfino', 'Zurich BlkEx BT', 'Zurich Ex BT', 'ZWAdobeF']
	      fontList = fontList.concat(extendedFontList)
	    }
	
	    fontList = fontList.concat(options.fonts.userDefinedFonts)
	
	      // remove duplicate fonts
	    fontList = fontList.filter(function (font, position) {
	      return fontList.indexOf(font) === position
	    })
	
	      // we use m or w because these two characters take up the maximum width.
	      // And we use a LLi so that the same matching fonts can get separated
	    var testString = 'mmmmmmmmmmlli'
	
	      // we test using 72px font size, we may use any size. I guess larger the better.
	    var testSize = '72px'
	
	    var h = document.getElementsByTagName('body')[0]
	
	      // div to load spans for the base fonts
	    var baseFontsDiv = document.createElement('div')
	
	      // div to load spans for the fonts to detect
	    var fontsDiv = document.createElement('div')
	
	    var defaultWidth = {}
	    var defaultHeight = {}
	
	      // creates a span where the fonts will be loaded
	    var createSpan = function () {
	      var s = document.createElement('span')
	        /*
	         * We need this css as in some weird browser this
	         * span elements shows up for a microSec which creates a
	         * bad user experience
	         */
	      s.style.position = 'absolute'
	      s.style.left = '-9999px'
	      s.style.fontSize = testSize
	
	        // css font reset to reset external styles
	      s.style.fontStyle = 'normal'
	      s.style.fontWeight = 'normal'
	      s.style.letterSpacing = 'normal'
	      s.style.lineBreak = 'auto'
	      s.style.lineHeight = 'normal'
	      s.style.textTransform = 'none'
	      s.style.textAlign = 'left'
	      s.style.textDecoration = 'none'
	      s.style.textShadow = 'none'
	      s.style.whiteSpace = 'normal'
	      s.style.wordBreak = 'normal'
	      s.style.wordSpacing = 'normal'
	
	      s.innerHTML = testString
	      return s
	    }
	
	      // creates a span and load the font to detect and a base font for fallback
	    var createSpanWithFonts = function (fontToDetect, baseFont) {
	      var s = createSpan()
	      s.style.fontFamily = "'" + fontToDetect + "'," + baseFont
	      return s
	    }
	
	      // creates spans for the base fonts and adds them to baseFontsDiv
	    var initializeBaseFontsSpans = function () {
	      var spans = []
	      for (var index = 0, length = baseFonts.length; index < length; index++) {
	        var s = createSpan()
	        s.style.fontFamily = baseFonts[index]
	        baseFontsDiv.appendChild(s)
	        spans.push(s)
	      }
	      return spans
	    }
	
	      // creates spans for the fonts to detect and adds them to fontsDiv
	    var initializeFontsSpans = function () {
	      var spans = {}
	      for (var i = 0, l = fontList.length; i < l; i++) {
	        var fontSpans = []
	        for (var j = 0, numDefaultFonts = baseFonts.length; j < numDefaultFonts; j++) {
	          var s = createSpanWithFonts(fontList[i], baseFonts[j])
	          fontsDiv.appendChild(s)
	          fontSpans.push(s)
	        }
	        spans[fontList[i]] = fontSpans // Stores {fontName : [spans for that font]}
	      }
	      return spans
	    }
	
	      // checks if a font is available
	    var isFontAvailable = function (fontSpans) {
	      var detected = false
	      for (var i = 0; i < baseFonts.length; i++) {
	        detected = (fontSpans[i].offsetWidth !== defaultWidth[baseFonts[i]] || fontSpans[i].offsetHeight !== defaultHeight[baseFonts[i]])
	        if (detected) {
	          return detected
	        }
	      }
	      return detected
	    }
	
	      // create spans for base fonts
	    var baseFontsSpans = initializeBaseFontsSpans()
	
	      // add the spans to the DOM
	    h.appendChild(baseFontsDiv)
	
	      // get the default width for the three base fonts
	    for (var index = 0, length = baseFonts.length; index < length; index++) {
	      defaultWidth[baseFonts[index]] = baseFontsSpans[index].offsetWidth // width for the default font
	      defaultHeight[baseFonts[index]] = baseFontsSpans[index].offsetHeight // height for the default font
	    }
	
	      // create spans for fonts to detect
	    var fontsSpans = initializeFontsSpans()
	
	      // add all the spans to the DOM
	    h.appendChild(fontsDiv)
	
	      // check available fonts
	    var available = []
	    for (var i = 0, l = fontList.length; i < l; i++) {
	      if (isFontAvailable(fontsSpans[fontList[i]])) {
	        available.push(fontList[i])
	      }
	    }
	
	      // remove spans from DOM
	    h.removeChild(fontsDiv)
	    h.removeChild(baseFontsDiv)
	    done(available)
	  }
	  var pluginsComponent = function (done, options) {
	    if (isIE()) {
	      if (!options.plugins.excludeIE) {
	        done(getIEPlugins(options))
	      } else {
	        done(options.EXCLUDED)
	      }
	    } else {
	      done(getRegularPlugins(options))
	    }
	  }
	  var getRegularPlugins = function (options) {
	    if (navigator.plugins == null) {
	      return options.NOT_AVAILABLE
	    }
	
	    var plugins = []
	      // plugins isn't defined in Node envs.
	    for (var i = 0, l = navigator.plugins.length; i < l; i++) {
	      if (navigator.plugins[i]) { plugins.push(navigator.plugins[i]) }
	    }
	
	      // sorting plugins only for those user agents, that we know randomize the plugins
	      // every time we try to enumerate them
	    if (pluginsShouldBeSorted(options)) {
	      plugins = plugins.sort(function (a, b) {
	        if (a.name > b.name) { return 1 }
	        if (a.name < b.name) { return -1 }
	        return 0
	      })
	    }
	    return map(plugins, function (p) {
	      var mimeTypes = map(p, function (mt) {
	        return [mt.type, mt.suffixes]
	      })
	      return [p.name, p.description, mimeTypes]
	    })
	  }
	  var getIEPlugins = function (options) {
	    var result = []
	    if ((Object.getOwnPropertyDescriptor && Object.getOwnPropertyDescriptor(window, 'ActiveXObject')) || ('ActiveXObject' in window)) {
	      var names = [
	        'AcroPDF.PDF', // Adobe PDF reader 7+
	        'Adodb.Stream',
	        'AgControl.AgControl', // Silverlight
	        'DevalVRXCtrl.DevalVRXCtrl.1',
	        'MacromediaFlashPaper.MacromediaFlashPaper',
	        'Msxml2.DOMDocument',
	        'Msxml2.XMLHTTP',
	        'PDF.PdfCtrl', // Adobe PDF reader 6 and earlier, brrr
	        'QuickTime.QuickTime', // QuickTime
	        'QuickTimeCheckObject.QuickTimeCheck.1',
	        'RealPlayer',
	        'RealPlayer.RealPlayer(tm) ActiveX Control (32-bit)',
	        'RealVideo.RealVideo(tm) ActiveX Control (32-bit)',
	        'Scripting.Dictionary',
	        'SWCtl.SWCtl', // ShockWave player
	        'Shell.UIHelper',
	        'ShockwaveFlash.ShockwaveFlash', // flash plugin
	        'Skype.Detection',
	        'TDCCtl.TDCCtl',
	        'WMPlayer.OCX', // Windows media player
	        'rmocx.RealPlayer G2 Control',
	        'rmocx.RealPlayer G2 Control.1'
	      ]
	        // starting to detect plugins in IE
	      result = map(names, function (name) {
	        try {
	            // eslint-disable-next-line no-new
	          new window.ActiveXObject(name)
	          return name
	        } catch (e) {
	          return options.ERROR
	        }
	      })
	    } else {
	      result.push(options.NOT_AVAILABLE)
	    }
	    if (navigator.plugins) {
	      result = result.concat(getRegularPlugins(options))
	    }
	    return result
	  }
	  var pluginsShouldBeSorted = function (options) {
	    var should = false
	    for (var i = 0, l = options.plugins.sortPluginsFor.length; i < l; i++) {
	      var re = options.plugins.sortPluginsFor[i]
	      if (navigator.userAgent.match(re)) {
	        should = true
	        break
	      }
	    }
	    return should
	  }
	  var touchSupportKey = function (done) {
	    done(getTouchSupport())
	  }
	  var hardwareConcurrencyKey = function (done, options) {
	    done(getHardwareConcurrency(options))
	  }
	  var hasSessionStorage = function (options) {
	    try {
	      return !!window.sessionStorage
	    } catch (e) {
	      return options.ERROR // SecurityError when referencing it means it exists
	    }
	  }
	
	// https://bugzilla.mozilla.org/show_bug.cgi?id=781447
	  var hasLocalStorage = function (options) {
	    try {
	      return !!window.localStorage
	    } catch (e) {
	      return options.ERROR // SecurityError when referencing it means it exists
	    }
	  }
	  var hasIndexedDB = function (options) {
	    try {
	      return !!window.indexedDB
	    } catch (e) {
	      return options.ERROR // SecurityError when referencing it means it exists
	    }
	  }
	  var getHardwareConcurrency = function (options) {
	    if (navigator.hardwareConcurrency) {
	      return navigator.hardwareConcurrency
	    }
	    return options.NOT_AVAILABLE
	  }
	  var getNavigatorCpuClass = function (options) {
	    return navigator.cpuClass || options.NOT_AVAILABLE
	  }
	  var getNavigatorPlatform = function (options) {
	    if (navigator.platform) {
	      return navigator.platform
	    } else {
	      return options.NOT_AVAILABLE
	    }
	  }
	  var getDoNotTrack = function (options) {
	    if (navigator.doNotTrack) {
	      return navigator.doNotTrack
	    } else if (navigator.msDoNotTrack) {
	      return navigator.msDoNotTrack
	    } else if (window.doNotTrack) {
	      return window.doNotTrack
	    } else {
	      return options.NOT_AVAILABLE
	    }
	  }
	// This is a crude and primitive touch screen detection.
	// It's not possible to currently reliably detect the  availability of a touch screen
	// with a JS, without actually subscribing to a touch event.
	// http://www.stucox.com/blog/you-cant-detect-a-touchscreen/
	// https://github.com/Modernizr/Modernizr/issues/548
	// method returns an array of 3 values:
	// maxTouchPoints, the success or failure of creating a TouchEvent,
	// and the availability of the 'ontouchstart' property
	
	  var getTouchSupport = function () {
	    var maxTouchPoints = 0
	    var touchEvent
	    if (typeof navigator.maxTouchPoints !== 'undefined') {
	      maxTouchPoints = navigator.maxTouchPoints
	    } else if (typeof navigator.msMaxTouchPoints !== 'undefined') {
	      maxTouchPoints = navigator.msMaxTouchPoints
	    }
	    try {
	      document.createEvent('TouchEvent')
	      touchEvent = true
	    } catch (_) {
	      touchEvent = false
	    }
	    var touchStart = 'ontouchstart' in window
	    return [maxTouchPoints, touchEvent, touchStart]
	  }
	// https://www.browserleaks.com/canvas#how-does-it-work
	
	  var getCanvasFp = function (options) {
	    var result = []
	      // Very simple now, need to make it more complex (geo shapes etc)
	    var canvas = document.createElement('canvas')
	    canvas.width = 2000
	    canvas.height = 200
	    canvas.style.display = 'inline'
	    var ctx = canvas.getContext('2d')
	      // detect browser support of canvas winding
	      // http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
	      // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/canvas/winding.js
	    ctx.rect(0, 0, 10, 10)
	    ctx.rect(2, 2, 6, 6)
	    result.push('canvas winding:' + ((ctx.isPointInPath(5, 5, 'evenodd') === false) ? 'yes' : 'no'))
	
	    ctx.textBaseline = 'alphabetic'
	    ctx.fillStyle = '#f60'
	    ctx.fillRect(125, 1, 62, 20)
	    ctx.fillStyle = '#069'
	      // https://github.com/Valve/fingerprintjs2/issues/66
	    if (options.dontUseFakeFontInCanvas) {
	      ctx.font = '11pt Arial'
	    } else {
	      ctx.font = '11pt no-real-font-123'
	    }
	    ctx.fillText('Cwm fjordbank glyphs vext quiz, \ud83d\ude03', 2, 15)
	    ctx.fillStyle = 'rgba(102, 204, 0, 0.2)'
	    ctx.font = '18pt Arial'
	    ctx.fillText('Cwm fjordbank glyphs vext quiz, \ud83d\ude03', 4, 45)
	
	      // canvas blending
	      // http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
	      // http://jsfiddle.net/NDYV8/16/
	    ctx.globalCompositeOperation = 'multiply'
	    ctx.fillStyle = 'rgb(255,0,255)'
	    ctx.beginPath()
	    ctx.arc(50, 50, 50, 0, Math.PI * 2, true)
	    ctx.closePath()
	    ctx.fill()
	    ctx.fillStyle = 'rgb(0,255,255)'
	    ctx.beginPath()
	    ctx.arc(100, 50, 50, 0, Math.PI * 2, true)
	    ctx.closePath()
	    ctx.fill()
	    ctx.fillStyle = 'rgb(255,255,0)'
	    ctx.beginPath()
	    ctx.arc(75, 100, 50, 0, Math.PI * 2, true)
	    ctx.closePath()
	    ctx.fill()
	    ctx.fillStyle = 'rgb(255,0,255)'
	      // canvas winding
	      // http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
	      // http://jsfiddle.net/NDYV8/19/
	    ctx.arc(75, 75, 75, 0, Math.PI * 2, true)
	    ctx.arc(75, 75, 25, 0, Math.PI * 2, true)
	    ctx.fill('evenodd')
	
	    if (canvas.toDataURL) { result.push('canvas fp:' + canvas.toDataURL()) }
	    return result
	  }
	  var getWebglFp = function () {
	    var gl
	    var fa2s = function (fa) {
	      gl.clearColor(0.0, 0.0, 0.0, 1.0)
	      gl.enable(gl.DEPTH_TEST)
	      gl.depthFunc(gl.LEQUAL)
	      gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT)
	      return '[' + fa[0] + ', ' + fa[1] + ']'
	    }
	    var maxAnisotropy = function (gl) {
	      var ext = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic')
	      if (ext) {
	        var anisotropy = gl.getParameter(ext.MAX_TEXTURE_MAX_ANISOTROPY_EXT)
	        if (anisotropy === 0) {
	          anisotropy = 2
	        }
	        return anisotropy
	      } else {
	        return null
	      }
	    }
	
	    gl = getWebglCanvas()
	    if (!gl) { return null }
	      // WebGL fingerprinting is a combination of techniques, found in MaxMind antifraud script & Augur fingerprinting.
	      // First it draws a gradient object with shaders and convers the image to the Base64 string.
	      // Then it enumerates all WebGL extensions & capabilities and appends them to the Base64 string, resulting in a huge WebGL string, potentially very unique on each device
	      // Since iOS supports webgl starting from version 8.1 and 8.1 runs on several graphics chips, the results may be different across ios devices, but we need to verify it.
	    var result = []
	    var vShaderTemplate = 'attribute vec2 attrVertex;varying vec2 varyinTexCoordinate;uniform vec2 uniformOffset;void main(){varyinTexCoordinate=attrVertex+uniformOffset;gl_Position=vec4(attrVertex,0,1);}'
	    var fShaderTemplate = 'precision mediump float;varying vec2 varyinTexCoordinate;void main() {gl_FragColor=vec4(varyinTexCoordinate,0,1);}'
	    var vertexPosBuffer = gl.createBuffer()
	    gl.bindBuffer(gl.ARRAY_BUFFER, vertexPosBuffer)
	    var vertices = new Float32Array([-0.2, -0.9, 0, 0.4, -0.26, 0, 0, 0.732134444, 0])
	    gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW)
	    vertexPosBuffer.itemSize = 3
	    vertexPosBuffer.numItems = 3
	    var program = gl.createProgram()
	    var vshader = gl.createShader(gl.VERTEX_SHADER)
	    gl.shaderSource(vshader, vShaderTemplate)
	    gl.compileShader(vshader)
	    var fshader = gl.createShader(gl.FRAGMENT_SHADER)
	    gl.shaderSource(fshader, fShaderTemplate)
	    gl.compileShader(fshader)
	    gl.attachShader(program, vshader)
	    gl.attachShader(program, fshader)
	    gl.linkProgram(program)
	    gl.useProgram(program)
	    program.vertexPosAttrib = gl.getAttribLocation(program, 'attrVertex')
	    program.offsetUniform = gl.getUniformLocation(program, 'uniformOffset')
	    gl.enableVertexAttribArray(program.vertexPosArray)
	    gl.vertexAttribPointer(program.vertexPosAttrib, vertexPosBuffer.itemSize, gl.FLOAT, !1, 0, 0)
	    gl.uniform2f(program.offsetUniform, 1, 1)
	    gl.drawArrays(gl.TRIANGLE_STRIP, 0, vertexPosBuffer.numItems)
	    try {
	      result.push(gl.canvas.toDataURL())
	    } catch (e) {
	        /* .toDataURL may be absent or broken (blocked by extension) */
	    }
	    result.push('extensions:' + (gl.getSupportedExtensions() || []).join(';'))
	    result.push('webgl aliased line width range:' + fa2s(gl.getParameter(gl.ALIASED_LINE_WIDTH_RANGE)))
	    result.push('webgl aliased point size range:' + fa2s(gl.getParameter(gl.ALIASED_POINT_SIZE_RANGE)))
	    result.push('webgl alpha bits:' + gl.getParameter(gl.ALPHA_BITS))
	    result.push('webgl antialiasing:' + (gl.getContextAttributes().antialias ? 'yes' : 'no'))
	    result.push('webgl blue bits:' + gl.getParameter(gl.BLUE_BITS))
	    result.push('webgl depth bits:' + gl.getParameter(gl.DEPTH_BITS))
	    result.push('webgl green bits:' + gl.getParameter(gl.GREEN_BITS))
	    result.push('webgl max anisotropy:' + maxAnisotropy(gl))
	    result.push('webgl max combined texture image units:' + gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS))
	    result.push('webgl max cube map texture size:' + gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE))
	    result.push('webgl max fragment uniform vectors:' + gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS))
	    result.push('webgl max render buffer size:' + gl.getParameter(gl.MAX_RENDERBUFFER_SIZE))
	    result.push('webgl max texture image units:' + gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS))
	    result.push('webgl max texture size:' + gl.getParameter(gl.MAX_TEXTURE_SIZE))
	    result.push('webgl max varying vectors:' + gl.getParameter(gl.MAX_VARYING_VECTORS))
	    result.push('webgl max vertex attribs:' + gl.getParameter(gl.MAX_VERTEX_ATTRIBS))
	    result.push('webgl max vertex texture image units:' + gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS))
	    result.push('webgl max vertex uniform vectors:' + gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS))
	    result.push('webgl max viewport dims:' + fa2s(gl.getParameter(gl.MAX_VIEWPORT_DIMS)))
	    result.push('webgl red bits:' + gl.getParameter(gl.RED_BITS))
	    result.push('webgl renderer:' + gl.getParameter(gl.RENDERER))
	    result.push('webgl shading language version:' + gl.getParameter(gl.SHADING_LANGUAGE_VERSION))
	    result.push('webgl stencil bits:' + gl.getParameter(gl.STENCIL_BITS))
	    result.push('webgl vendor:' + gl.getParameter(gl.VENDOR))
	    result.push('webgl version:' + gl.getParameter(gl.VERSION))
	
	    try {
	        // Add the unmasked vendor and unmasked renderer if the debug_renderer_info extension is available
	      var extensionDebugRendererInfo = gl.getExtension('WEBGL_debug_renderer_info')
	      if (extensionDebugRendererInfo) {
	        result.push('webgl unmasked vendor:' + gl.getParameter(extensionDebugRendererInfo.UNMASKED_VENDOR_WEBGL))
	        result.push('webgl unmasked renderer:' + gl.getParameter(extensionDebugRendererInfo.UNMASKED_RENDERER_WEBGL))
	      }
	    } catch (e) { /* squelch */ }
	
	    if (!gl.getShaderPrecisionFormat) {
	      return result
	    }
	
	    each(['FLOAT', 'INT'], function (numType) {
	      each(['VERTEX', 'FRAGMENT'], function (shader) {
	        each(['HIGH', 'MEDIUM', 'LOW'], function (numSize) {
	          each(['precision', 'rangeMin', 'rangeMax'], function (key) {
	            var format = gl.getShaderPrecisionFormat(gl[shader + '_SHADER'], gl[numSize + '_' + numType])[key]
	            if (key !== 'precision') {
	              key = 'precision ' + key
	            }
	            var line = ['webgl ', shader.toLowerCase(), ' shader ', numSize.toLowerCase(), ' ', numType.toLowerCase(), ' ', key, ':', format].join('')
	            result.push(line)
	          })
	        })
	      })
	    })
	    return result
	  }
	  var getWebglVendorAndRenderer = function () {
	      /* This a subset of the WebGL fingerprint with a lot of entropy, while being reasonably browser-independent */
	    try {
	      var glContext = getWebglCanvas()
	      var extensionDebugRendererInfo = glContext.getExtension('WEBGL_debug_renderer_info')
	      return glContext.getParameter(extensionDebugRendererInfo.UNMASKED_VENDOR_WEBGL) + '~' + glContext.getParameter(extensionDebugRendererInfo.UNMASKED_RENDERER_WEBGL)
	    } catch (e) {
	      return null
	    }
	  }
	  var getAdBlock = function () {
	    var ads = document.createElement('div')
	    ads.innerHTML = '&nbsp;'
	    ads.className = 'adsbox'
	    var result = false
	    try {
	        // body may not exist, that's why we need try/catch
	      document.body.appendChild(ads)
	      result = document.getElementsByClassName('adsbox')[0].offsetHeight === 0
	      document.body.removeChild(ads)
	    } catch (e) {
	      result = false
	    }
	    return result
	  }
	  var getHasLiedLanguages = function () {
	      // We check if navigator.language is equal to the first language of navigator.languages
	    if (typeof navigator.languages !== 'undefined') {
	      try {
	        var firstLanguages = navigator.languages[0].substr(0, 2)
	        if (firstLanguages !== navigator.language.substr(0, 2)) {
	          return true
	        }
	      } catch (err) {
	        return true
	      }
	    }
	    return false
	  }
	  var getHasLiedResolution = function () {
	    return window.screen.width < window.screen.availWidth || window.screen.height < window.screen.availHeight
	  }
	  var getHasLiedOs = function () {
	    var userAgent = navigator.userAgent.toLowerCase()
	    var oscpu = navigator.oscpu
	    var platform = navigator.platform.toLowerCase()
	    var os
	      // We extract the OS from the user agent (respect the order of the if else if statement)
	    if (userAgent.indexOf('windows phone') >= 0) {
	      os = 'Windows Phone'
	    } else if (userAgent.indexOf('win') >= 0) {
	      os = 'Windows'
	    } else if (userAgent.indexOf('android') >= 0) {
	      os = 'Android'
	    } else if (userAgent.indexOf('linux') >= 0) {
	      os = 'Linux'
	    } else if (userAgent.indexOf('iphone') >= 0 || userAgent.indexOf('ipad') >= 0) {
	      os = 'iOS'
	    } else if (userAgent.indexOf('mac') >= 0) {
	      os = 'Mac'
	    } else {
	      os = 'Other'
	    }
	      // We detect if the person uses a mobile device
	    var mobileDevice = (('ontouchstart' in window) ||
	        (navigator.maxTouchPoints > 0) ||
	        (navigator.msMaxTouchPoints > 0))
	
	    if (mobileDevice && os !== 'Windows Phone' && os !== 'Android' && os !== 'iOS' && os !== 'Other') {
	      return true
	    }
	
	      // We compare oscpu with the OS extracted from the UA
	    if (typeof oscpu !== 'undefined') {
	      oscpu = oscpu.toLowerCase()
	      if (oscpu.indexOf('win') >= 0 && os !== 'Windows' && os !== 'Windows Phone') {
	        return true
	      } else if (oscpu.indexOf('linux') >= 0 && os !== 'Linux' && os !== 'Android') {
	        return true
	      } else if (oscpu.indexOf('mac') >= 0 && os !== 'Mac' && os !== 'iOS') {
	        return true
	      } else if ((oscpu.indexOf('win') === -1 && oscpu.indexOf('linux') === -1 && oscpu.indexOf('mac') === -1) !== (os === 'Other')) {
	        return true
	      }
	    }
	
	      // We compare platform with the OS extracted from the UA
	    if (platform.indexOf('win') >= 0 && os !== 'Windows' && os !== 'Windows Phone') {
	      return true
	    } else if ((platform.indexOf('linux') >= 0 || platform.indexOf('android') >= 0 || platform.indexOf('pike') >= 0) && os !== 'Linux' && os !== 'Android') {
	      return true
	    } else if ((platform.indexOf('mac') >= 0 || platform.indexOf('ipad') >= 0 || platform.indexOf('ipod') >= 0 || platform.indexOf('iphone') >= 0) && os !== 'Mac' && os !== 'iOS') {
	      return true
	    } else if ((platform.indexOf('win') === -1 && platform.indexOf('linux') === -1 && platform.indexOf('mac') === -1) !== (os === 'Other')) {
	      return true
	    }
	
	    return typeof navigator.plugins === 'undefined' && os !== 'Windows' && os !== 'Windows Phone'
	  }
	  var getHasLiedBrowser = function () {
	    var userAgent = navigator.userAgent.toLowerCase()
	    var productSub = navigator.productSub
	
	      // we extract the browser from the user agent (respect the order of the tests)
	    var browser
	    if (userAgent.indexOf('firefox') >= 0) {
	      browser = 'Firefox'
	    } else if (userAgent.indexOf('opera') >= 0 || userAgent.indexOf('opr') >= 0) {
	      browser = 'Opera'
	    } else if (userAgent.indexOf('chrome') >= 0) {
	      browser = 'Chrome'
	    } else if (userAgent.indexOf('safari') >= 0) {
	      browser = 'Safari'
	    } else if (userAgent.indexOf('trident') >= 0) {
	      browser = 'Internet Explorer'
	    } else {
	      browser = 'Other'
	    }
	
	    if ((browser === 'Chrome' || browser === 'Safari' || browser === 'Opera') && productSub !== '20030107') {
	      return true
	    }
	
	      // eslint-disable-next-line no-eval
	    var tempRes = eval.toString().length
	    if (tempRes === 37 && browser !== 'Safari' && browser !== 'Firefox' && browser !== 'Other') {
	      return true
	    } else if (tempRes === 39 && browser !== 'Internet Explorer' && browser !== 'Other') {
	      return true
	    } else if (tempRes === 33 && browser !== 'Chrome' && browser !== 'Opera' && browser !== 'Other') {
	      return true
	    }
	
	      // We create an error to see how it is handled
	    var errFirefox
	    try {
	        // eslint-disable-next-line no-throw-literal
	      throw 'a'
	    } catch (err) {
	      try {
	        err.toSource()
	        errFirefox = true
	      } catch (errOfErr) {
	        errFirefox = false
	      }
	    }
	    return errFirefox && browser !== 'Firefox' && browser !== 'Other'
	  }
	  var isCanvasSupported = function () {
	    var elem = document.createElement('canvas')
	    return !!(elem.getContext && elem.getContext('2d'))
	  }
	  var isWebGlSupported = function () {
	      // code taken from Modernizr
	    if (!isCanvasSupported()) {
	      return false
	    }
	
	    var glContext = getWebglCanvas()
	    return !!window.WebGLRenderingContext && !!glContext
	  }
	  var isIE = function () {
	    if (navigator.appName === 'Microsoft Internet Explorer') {
	      return true
	    } else if (navigator.appName === 'Netscape' && /Trident/.test(navigator.userAgent)) { // IE 11
	      return true
	    }
	    return false
	  }
	  var hasSwfObjectLoaded = function () {
	    return typeof window.swfobject !== 'undefined'
	  }
	  var hasMinFlashInstalled = function () {
	    return window.swfobject.hasFlashPlayerVersion('9.0.0')
	  }
	  var addFlashDivNode = function (options) {
	    var node = document.createElement('div')
	    node.setAttribute('id', options.fonts.swfContainerId)
	    document.body.appendChild(node)
	  }
	  var loadSwfAndDetectFonts = function (done, options) {
	    var hiddenCallback = '___fp_swf_loaded'
	    window[hiddenCallback] = function (fonts) {
	      done(fonts)
	    }
	    var id = options.fonts.swfContainerId
	    addFlashDivNode()
	    var flashvars = { onReady: hiddenCallback }
	    var flashparams = { allowScriptAccess: 'always', menu: 'false' }
	    window.swfobject.embedSWF(options.fonts.swfPath, id, '1', '1', '9.0.0', false, flashvars, flashparams, {})
	  }
	  var getWebglCanvas = function () {
	    var canvas = document.createElement('canvas')
	    var gl = null
	    try {
	      gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
	    } catch (e) { /* squelch */ }
	    if (!gl) { gl = null }
	    return gl
	  }
	
	  var components = [
	    {key: 'userAgent', getData: UserAgent},
	    {key: 'language', getData: languageKey},
	    {key: 'colorDepth', getData: colorDepthKey},
	    {key: 'deviceMemory', getData: deviceMemoryKey},
	    {key: 'pixelRatio', getData: pixelRatioKey},
	    {key: 'hardwareConcurrency', getData: hardwareConcurrencyKey},
	    {key: 'screenResolution', getData: screenResolutionKey},
	    {key: 'availableScreenResolution', getData: availableScreenResolutionKey},
	    {key: 'timezoneOffset', getData: timezoneOffset},
	    {key: 'timezone', getData: timezone},
	    {key: 'sessionStorage', getData: sessionStorageKey},
	    {key: 'localStorage', getData: localStorageKey},
	    {key: 'indexedDb', getData: indexedDbKey},
	    {key: 'addBehavior', getData: addBehaviorKey},
	    {key: 'openDatabase', getData: openDatabaseKey},
	    {key: 'cpuClass', getData: cpuClassKey},
	    {key: 'platform', getData: platformKey},
	    {key: 'doNotTrack', getData: doNotTrackKey},
	    {key: 'plugins', getData: pluginsComponent},
	    {key: 'canvas', getData: canvasKey},
	    {key: 'webgl', getData: webglKey},
	    {key: 'webglVendorAndRenderer', getData: webglVendorAndRendererKey},
	    {key: 'adBlock', getData: adBlockKey},
	    {key: 'hasLiedLanguages', getData: hasLiedLanguagesKey},
	    {key: 'hasLiedResolution', getData: hasLiedResolutionKey},
	    {key: 'hasLiedOs', getData: hasLiedOsKey},
	    {key: 'hasLiedBrowser', getData: hasLiedBrowserKey},
	    {key: 'touchSupport', getData: touchSupportKey},
	    {key: 'fonts', getData: jsFontsKey, pauseBefore: true},
	    {key: 'fontsFlash', getData: flashFontsKey, pauseBefore: true},
	    {key: 'audio', getData: audioKey},
	    {key: 'enumerateDevices', getData: enumerateDevicesKey}
	  ]
	
	  var Fingerprint2 = function (options) {
	    throw new Error("'new Fingerprint()' is deprecated, see https://github.com/Valve/fingerprintjs2#upgrade-guide-from-182-to-200")
	  }
	
	  Fingerprint2.get = function (options, callback) {
	    if (!callback) {
	      callback = options
	      options = {}
	    } else if (!options) {
	      options = {}
	    }
	    extendSoft(options, defaultOptions)
	    options.components = options.extraComponents.concat(components)
	
	    var keys = {
	      data: [],
	      addPreprocessedComponent: function (key, value) {
	        if (typeof options.preprocessor === 'function') {
	          value = options.preprocessor(key, value)
	        }
	        keys.data.push({key: key, value: value})
	      }
	    }
	
	    var i = -1
	    var chainComponents = function (alreadyWaited) {
	      i += 1
	      if (i >= options.components.length) { // on finish
	        callback(keys.data)
	        return
	      }
	      var component = options.components[i]
	
	      if (options.excludes[component.key]) {
	        chainComponents(false) // skip
	        return
	      }
	
	      if (!alreadyWaited && component.pauseBefore) {
	        i -= 1
	        setTimeout(function () {
	          chainComponents(true)
	        }, 1)
	        return
	      }
	
	      try {
	        component.getData(function (value) {
	          keys.addPreprocessedComponent(component.key, value)
	          chainComponents(false)
	        }, options)
	      } catch (error) {
	        // main body error
	        keys.addPreprocessedComponent(component.key, String(error))
	        chainComponents(false)
	      }
	    }
	
	    chainComponents(false)
	  }
	
	  Fingerprint2.getPromise = function (options) {
	    return new Promise(function (resolve, reject) {
	      Fingerprint2.get(options, resolve)
	    })
	  }
	
	  Fingerprint2.getV18 = function (options, callback) {
	    if (callback == null) {
	      callback = options
	      options = {}
	    }
	    return Fingerprint2.get(options, function (components) {
	      var newComponents = []
	      for (var i = 0; i < components.length; i++) {
	        var component = components[i]
	        if (component.value === (options.NOT_AVAILABLE || 'not available')) {
	          newComponents.push({key: component.key, value: 'unknown'})
	        } else if (component.key === 'plugins') {
	          newComponents.push({key: 'plugins',
	            value: map(component.value, function (p) {
	              var mimeTypes = map(p[2], function (mt) {
	                if (mt.join) { return mt.join('~') }
	                return mt
	              }).join(',')
	              return [p[0], p[1], mimeTypes].join('::')
	            })})
	        } else if (['canvas', 'webgl'].indexOf(component.key) !== -1) {
	          newComponents.push({key: component.key, value: component.value.join('~')})
	        } else if (['sessionStorage', 'localStorage', 'indexedDb', 'addBehavior', 'openDatabase'].indexOf(component.key) !== -1) {
	          if (component.value) {
	            newComponents.push({key: component.key, value: 1})
	          } else {
	            // skip
	            continue
	          }
	        } else {
	          if (component.value) {
	            newComponents.push(component.value.join ? {key: component.key, value: component.value.join(';')} : component)
	          } else {
	            newComponents.push({key: component.key, value: component.value})
	          }
	        }
	      }
	      var murmur = x64hash128(map(newComponents, function (component) { return component.value }).join('~~~'), 31)
	      callback(murmur, newComponents)
	    })
	  }
	
	  Fingerprint2.x64hash128 = x64hash128
	  Fingerprint2.VERSION = '2.0.0'
	  return Fingerprint2
	})


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// funnel.js